{
  "account.account": "Profil i bezpieczeństwo",
  "account.accountDeleted": "Twoje konto zostało pomyślnie usunięte.",
  "account.accountDescription": "Imię, hasło, usunięcie konta",
  "account.accountSection": "Konto",
  "account.changeEmail": "Zmień e-mail",
  "account.changePassword": "Zmień hasło",
  "account.currentPassword": "Aktualne hasło",
  "account.dangerZone": "Strefa ryzyka",
  "account.deleteAccount": "Usuń konto",
  "account.deleteAccountConfirmation": "Czy na pewno chcesz usunąć swoje konto? Ta czynność jest nieodwracalna.",
  "account.deleteAccountDescription": "Ta czynność usuwa Twoje konto i wszystkie informacje. Nie ma powrotu.",
  "account.emailChange": "Zmień adres e-mail",
  "account.emailChangeConfirmation": "Potwierdzenie zmiany e-maila",
  "account.emailChangeFailure": "Link do zmiany e-maila jest nieprawidłowy lub wygasł.",
  "account.emailChangeIntro": "Wpisz nowy adres e-mail i obecne hasło. Wyślemy link na nowy adres: adres e-mail zmieni się dopiero po jego otwarciu.",
  "account.emailChangeSuccess": "Twój e-mail został pomyślnie zmieniony na {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Twój adres e-mail został pomyślnie zmieniony.",
  "account.emailChangeVerificationSent": "E-mail weryfikacyjny został wysłany na Twój nowy adres e-mail. Sprawdź swoją skrzynkę odbiorczą i kliknij link, aby potwierdzić zmianę.",
  "account.manageAccount": "Zarządzaj kontem",
  "account.newEmailAddress": "Nowy adres e-mail",
  "account.newPassword": "Nowe hasło",
  "account.newPasswordAgain": "Powtórz nowe hasło",
  "account.oldPassword": "Stare hasło",
  "account.passwordChange": "Zmiana hasła",
  "account.passwordChangeDescription": "Zadbaj o bezpieczeństwo konta",
  "account.passwordUpdated": "Hasło zostało pomyślnie zaktualizowane.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil został pomyślnie zaktualizowany.",
  "account.signedInAs": "Zalogowano jako",
  "account.updateYourProfile": "Zaktualizuj swój profil",
  "account.updateYourProfileDescription": "Imię i preferencje wyświetlania",
  "addons.accountOnHold": "Połączenie z kontem wygasło. Połącz się ponownie, aby wznowić aktualizacje danych.",
  "addons.accountOnHoldTitle": "Konto wstrzymane",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Utwórz klucz API z podanego linku",
  "addons.ambientWeatherDescription": "Stacje pogodowe Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Klucz API",
  "addons.applicationKey": "Klucz aplikacji",
  "addons.availableServices": "Dostępne",
  "addons.cannotDisconnectLastAccount": "Nie można odłączyć jedynej metody logowania. Najpierw dodaj inną metodę logowania.",
  "addons.connect": "Połącz",
  "addons.connected": "Połączono",
  "addons.connectedAccounts": "Połączone konta",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Wczytywanie połączonych kont…",
  "addons.connectedServices": "Połączone",
  "addons.connectedSince": "Połączono od {date}",
  "addons.connectionSection": "Połączenie",
  "addons.connectionSuccess": "Konto {provider} połączone pomyślnie",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Klucz API V2",
  "addons.davisDescription": "Stacje pogodowe Davisa (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Pobierz klucze API V2 z tego linku",
  "addons.disconnect": "Odłącz",
  "addons.disconnectConfirmation": "Czy na pewno chcesz odłączyć swoje konto {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin przestanie synchronizować Netatmo Energy i usunie Twoje domy z SmartMixin. Twoje konto Netatmo i urządzenia pozostaną bez zmian.",
  "addons.disconnectEnergyDescription": "Zatrzymuje synchronizację i usuwa Twoje domy z SmartMixin.",
  "addons.disconnectionSuccess": "Konto {provider} odłączone pomyślnie",
  "addons.disconnectProviderDescription": "Zatrzymuje synchronizację i usuwa stacje tej usługi wraz z ich historią.",
  "addons.disconnectServiceConfirmation": "SmartMixin przestanie synchronizować usługę {provider} i usunie stacje tej usługi wraz z całą ich historią. Samo Twoje konto w usłudze {provider} pozostanie bez zmian.",
  "addons.disconnectServiceTitle": "Odłączyć usługę {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Utwórz i pobierz swój klucz API i klucz aplikacji, korzystając z tego łącza",
  "addons.ecowittDescription": "Ecowitt zapewnia profesjonalną stację pogodową Wi-Fi, bezprzewodowe termometry wewnętrzne i zewnętrzne, monitory wilgotności, precyzyjne mierniki deszczu, monitory jakości powietrza i wiele innych.",
  "addons.helpLink": "Jak połączyć {provider}",
  "addons.integrationsSection": "Integracje",
  "addons.myAcuriteAccountOnHold": "Twoje konto zostało zawieszone. Wprowadź hasło, aby ponownie połączyć swoje konto",
  "addons.myAcuriteDescription": "AcuRite to marka stacji pogodowych nr 1 w Ameryce Północnej. Jako lider w technologii pomiaru czasu, temperatury i pogody, AcuRite dostarcza szczegółowych informacji o środowisku wewnętrznym i zewnętrznym, dzięki czemu możesz bezpiecznie zaplanować swój dzień.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Użyj swojego termostatu Netatmo, aby zmienić temperaturę w domu, z łóżka lub z drugiego końca świata.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Twoja osobista stacja pogodowa w domu",
  "addons.notConnected": "Niepołączono",
  "addons.or": "lub",
  "addons.providerAccountDisconnected": "Połączenie z usługą pogodową wygasło. Połącz się ponownie, aby wznowić aktualizacje danych.",
  "addons.reconnect": "Połącz ponownie",
  "addons.socialConnectionsIntro": "Połącz swoje konta społecznościowe, aby szybko się logować. Możesz połączyć lub odłączyć konta w dowolnym momencie.",
  "addons.weatherflowAccessToken": "Token dostępu",
  "addons.weatherflowCreateToken": "Utwórz token z podanego linku",
  "addons.weatherflowTempestDescription": "System pogodowy Tempest z wbudowanym wiatromierzem i deszczomierzem",
  "addons.weatherServices": "Usługi pogodowe",
  "addons.weatherServicesConnected": "{count, plural, =0 {Brak połączonych usług} one {# połączona usługa} few {# połączone usługi} many {# połączonych usług} other {# połączonych usług}}",
  "addons.weatherServicesDescription": "Połącz Netatmo, Davis, Weatherflow i inne",
  "addons.wundergroundApiKey": "Klucz API",
  "addons.wundergroundDescription": "Weather Underground to globalna społeczność ludzi łącząca dane z czujników środowiskowych, takich jak stacje pogodowe i monitory jakości powietrza, dzięki czemu możemy dostarczać bogate, hiperlokalne dane, których potrzebujesz do realizacji swoich pasji",
  "addons.wundergroundRemoveStationDescription": "Stacja zostanie usunięta z Twojego konta SmartMixin. Jeśli żadne inne konto SmartMixin jej nie dodało, stacja i historia zapisana dla niej przez SmartMixin zostaną usunięte. W Weather Underground nic się nie zmienia.",
  "addons.wundergroundRemoveStationTitle": "Usunąć {station}?",
  "addons.wundergroundRetrieveApiKey": "Pobierz swój klucz API z tego linku",
  "addons.wundergroundStationId": "ID Stacji",
  "airQuality.adviceActivityGood": "Idealny dzień na aktywność na zewnątrz",
  "airQuality.adviceActivityHazardous": "Unikaj wszelkiej aktywności fizycznej na zewnątrz",
  "airQuality.adviceActivityLabel": "Aktywność fizyczna",
  "airQuality.adviceActivityModerate": "Dobry dzień na aktywność na zewnątrz",
  "airQuality.adviceActivitySensitive": "Rozważ krótszą i mniej intensywną aktywność na zewnątrz",
  "airQuality.adviceActivityUnhealthy": "Ogranicz długie lub intensywne aktywności i rób więcej przerw",
  "airQuality.adviceActivityVeryUnhealthy": "Unikaj długich lub intensywnych aktywności; rozważ przeniesienie ich do pomieszczeń",
  "airQuality.adviceGroupsGood": "Nie są potrzebne szczególne środki ostrożności",
  "airQuality.adviceGroupsHazardous": "Zostań w pomieszczeniu i ogranicz aktywność",
  "airQuality.adviceGroupsLabel": "Grupy wrażliwe",
  "airQuality.adviceGroupsModerate": "Osoby szczególnie wrażliwe: krótsza i mniej intensywna aktywność",
  "airQuality.adviceGroupsSensitive": "Krótsza i mniej intensywna aktywność na zewnątrz oraz więcej przerw",
  "airQuality.adviceGroupsUnhealthy": "Unikaj długich lub intensywnych aktywności na zewnątrz; rozważ przeniesienie ich do pomieszczeń",
  "airQuality.adviceGroupsVeryUnhealthy": "Unikaj wszelkiej aktywności fizycznej na zewnątrz; przełóż ją lub przenieś do pomieszczenia",
  "airQuality.adviceTimingLabel": "Kiedy wyjść",
  "airQuality.adviceTimingMorning": "Najlepiej rano — wtedy poziom ozonu jest niższy",
  "airQuality.airQuality": "Jakość powietrza",
  "airQuality.airQualityIndex": "Indeks jakości powietrza",
  "airQuality.aqiForecast": "Prognoza jakości powietrza",
  "airQuality.co2Fresh": "Świeże",
  "airQuality.co2GettingStale": "Lekko duszno",
  "airQuality.co2Stale": "Duszno",
  "airQuality.dailyForecast": "Prognoza dzienna",
  "airQuality.dominantPollutant": "Dominujące zanieczyszczenie",
  "airQuality.expectedPeak": "Oczekiwany szczyt",
  "airQuality.good": "Dobra",
  "airQuality.goodDescription": "Jakość powietrza jest uznawana za zadowalającą, a zanieczyszczenie powietrza stanowi niewielkie ryzyko lub jego brak.",
  "airQuality.hazardous": "Niebezpieczna",
  "airQuality.hazardousDescription": "Alarm Zdrowotny: każdy może doświadczyć poważniejszych skutków zdrowotnych.",
  "airQuality.indoorAirQuality": "Jakość powietrza wewnątrz",
  "airQuality.moderate": "Średnia",
  "airQuality.moderateDescription": "Jakość powietrza jest dopuszczalna; jednak niektóre zanieczyszczenia mogą być umiarkowanie szkodliwe dla bardzo małej liczby osób, które są niezwykle wrażliwe na zanieczyszczenie powietrza.",
  "airQuality.noForecastForLocation": "Brak dostępnej prognozy jakości powietrza dla tej lokalizacji.",
  "airQuality.now": "Teraz",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Zanieczyszczenia",
  "airQuality.recommendations": "Zalecenia",
  "airQuality.sensitiveUnhealthy": "Niezdrowa dla grup wrażliwych",
  "airQuality.sensitiveUnhealthyDescription": "U osób wrażliwych mogą wystąpić negatywne skutki dla zdrowia. Większość populacji może nie odczuwać negatywnych objawów.",
  "airQuality.subIndex": "Podindeks AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Zrozumieć indeks",
  "airQuality.unhealthy": "Niezdrowa",
  "airQuality.unhealthyDescription": "Każdy może zacząć doświadczać negatywnych skutków zdrowotnych; U osób wrażliwych mogą wystąpić poważniejsze skutki zdrowotne.",
  "airQuality.veryUnhealthy": "Bardzo niezdrowa",
  "airQuality.veryUnhealthyDescription": "Ostrzeżenie zdrowotne, poziom alarmowy. Bardzo prawdopodobny negatywny wpływ na całą populację.",
  "alerts.addAlert": "Dodaj alert",
  "alerts.addCondition": "Dodaj warunek",
  "alerts.alertAdded": "Alarm poprawnie dodany",
  "alerts.alertAuthorizationNotice": "Alarmy działają tylko jeśli SmartMixin ma pozwolenie na wyświetlanie powiadomień",
  "alerts.alertDeleted": "Alarm poprawnie usunięty",
  "alerts.alertName": "Nazwa alarmu",
  "alerts.alertWhen": "Chce być ostrzegany kiedy:",
  "alerts.aqiGreaterThan": "AQI większe niż",
  "alerts.aqiGreaterThanThreshold": "AQI większe niż {value}{unit}",
  "alerts.aqiLessThan": "AQI mniejsze niż",
  "alerts.aqiLessThanThreshold": "AQI mniejsze niż {value}{unit}",
  "alerts.atLeastOneCondition": "Musisz dodać co najmniej jeden warunek",
  "alerts.co2GreaterThan": "CO2 większe niż",
  "alerts.co2GreaterThanThreshold": "CO2 większe niż {value}{unit}",
  "alerts.co2LessThan": "CO2 mniejsze niż",
  "alerts.co2LessThanThreshold": "CO2 mniejsze niż {value}{unit}",
  "alerts.conditions": "Warunki",
  "alerts.conditionsDroppedOnStationChange": "Nieobsługiwane przez tę stację, usunięto: {conditions}",
  "alerts.createAlert": "Utwórz alarm",
  "alerts.dailyPrecipitationGreaterThan": "Opady dobowe większe niż",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Opady dobowe przekraczające próg {value}{unit}",
  "alerts.deleteAlert": "Usuń alarm",
  "alerts.editAlert": "Edytuj alarm",
  "alerts.editCondition": "Edytuj warunek",
  "alerts.gustSpeedGreaterThan": "Podmuch wiatru większy niż",
  "alerts.gustSpeedGreaterThanThreshold": "Porywy wiatru większe niż {value}{unit}",
  "alerts.gustSpeedLessThan": "Porywy wiatru mniejsze niż",
  "alerts.gustSpeedLessThanThreshold": "Porywy wiatru mniejsze niż {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indeks ciepła większy niż",
  "alerts.heatIndexGreaterThanThreshold": "Indeks ciepła większy niż {value}{unit}",
  "alerts.heatIndexLessThan": "Indeks ciepła mniejszy niż",
  "alerts.heatIndexLessThanThreshold": "Indeks ciepła mniejszy niż {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex większy niż",
  "alerts.humidexGreaterThanThreshold": "Humidex większy niż {value}{unit}",
  "alerts.humidexLessThan": "Humidex mniejszy niż",
  "alerts.humidexLessThanThreshold": "Humidex mniejszy niż {value}{unit}",
  "alerts.humidityGreaterThan": "Wilgotność większa niż",
  "alerts.humidityGreaterThanThreshold": "Wilgotność większa niż {value}{unit}",
  "alerts.humidityLessThan": "Wilgotność mniejsza niż",
  "alerts.humidityLessThanThreshold": "Wilgotność mniejsza niż {value}{unit}",
  "alerts.inProgress": "W trakcie",
  "alerts.leafWetnessGreaterThan": "Wilgotność liści większa niż",
  "alerts.leafWetnessGreaterThanThreshold": "Wilgotność liści większa niż {value}{unit}",
  "alerts.leafWetnessLessThan": "Wilgotność liści mniejsza niż",
  "alerts.leafWetnessLessThanThreshold": "Wilgotność liści mniejsza niż {value}{unit}",
  "alerts.myAlerts": "Moje alarmy",
  "alerts.noConfiguredAlert": "Nie masz skonfigurowanego żadnego alarmu, dodaj jakiś",
  "alerts.noiseGreaterThan": "Hałas większy niż",
  "alerts.noiseGreaterThanThreshold": "Hałas większy niż {value}{unit}",
  "alerts.noiseLessThan": "Hałas mniejszy niż",
  "alerts.noiseLessThanThreshold": "Hałas mniejszy niż {value}{unit}",
  "alerts.noteOnConditions": "Pamiętaj, że alert jest wyzwalany, gdy wszystkie poniższe warunki zostaną zweryfikowane",
  "alerts.noTriggerHistory": "Ten alert nie został jeszcze wyzwolony.",
  "alerts.pm10GreaterThan": "PM10 większe niż",
  "alerts.pm10GreaterThanThreshold": "PM10 większe niż {value}{unit}",
  "alerts.pm10LessThan": "PM10 mniejsze niż",
  "alerts.pm10LessThanThreshold": "PM10 mniejsze niż {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 większe niż",
  "alerts.pm1GreaterThanThreshold": "PM 1 większe niż {value}{unit}",
  "alerts.pm1LessThan": "PM 1 mniejsze niż",
  "alerts.pm1LessThanThreshold": "PM 1 mniejsze niż {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 większe niż",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 większe niż {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 mniejsze niż",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 mniejsze niż {value}{unit}",
  "alerts.postStormSummary": "Podsumowanie opadów",
  "alerts.postStormSynopsisHelper": "Otrzymasz powiadomienie z podsumowaniem po zakończeniu każdych opadów.",
  "alerts.postStormSynopsisSoleCondition": "Podsumowania opadów nie można łączyć z innymi warunkami.",
  "alerts.precipitationGreaterThan": "Opady godzinowe większe niż",
  "alerts.precipitationGreaterThanThreshold": "Opady godzinowe przekraczające próg {value}{unit}",
  "alerts.pressureGreaterThan": "Ciśnienie większe niż",
  "alerts.pressureGreaterThanThreshold": "Ciśnienie większe niż {value}{unit}",
  "alerts.pressureLessThan": "Ciśnienie mniejsze niż",
  "alerts.pressureLessThanThreshold": "Ciśnienie mniejsze niż {value}{unit}",
  "alerts.rainRateGreaterThan": "Natężenie deszczu większe niż",
  "alerts.rainRateGreaterThanThreshold": "Natężenie deszczu przekraczające próg {value}{unit}",
  "alerts.sensorNotReporting": "Ten czujnik obecnie nie przesyła danych. Alarm zostanie wznowiony, gdy znów zacznie je przesyłać.",
  "alerts.soilMoistureGreaterThan": "Wilgotność gleby większa niż",
  "alerts.soilMoistureGreaterThanThreshold": "Wilgotność gleby większa niż {value}{unit}",
  "alerts.soilMoistureLessThan": "Wilgotność gleby mniejsza niż",
  "alerts.soilMoistureLessThanThreshold": "Wilgotność gleby mniejsza niż {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Nasłonecznienie większe niż",
  "alerts.solarRadiationGreaterThanThreshold": "Nasłonecznienie większe niż {value}{unit}",
  "alerts.solarRadiationLessThan": "Nasłonecznienie mniejsze niż",
  "alerts.solarRadiationLessThanThreshold": "Nasłonecznienie mniejsze niż {value}{unit}",
  "alerts.stationNoLongerReports": "Ta stacja nie przesyła już danych, więc ten alarm nie może się uruchomić.",
  "alerts.stormChartUnavailable": "Historia deszczu dla tych opadów jest niedostępna.",
  "alerts.stormDetail": "Podsumowanie opadów",
  "alerts.stormDuration": "Czas trwania",
  "alerts.stormEnd": "Koniec",
  "alerts.stormPeakRate": "Maksymalne natężenie deszczu",
  "alerts.stormStart": "Początek",
  "alerts.stormTotal": "Suma opadów",
  "alerts.temperatureGreaterThan": "Temperatura większa niż",
  "alerts.temperatureGreaterThanThreshold": "Temperatura większa niż {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura mniejsza niż",
  "alerts.temperatureLessThanThreshold": "Temperatura mniejsza niż {value}{unit}",
  "alerts.thresholdOutOfRange": "Musi być między {min} a {max}",
  "alerts.thswGreaterThan": "THSW większy niż",
  "alerts.thswGreaterThanThreshold": "THSW większy niż {value}{unit}",
  "alerts.thswLessThan": "THSW mniejszy niż",
  "alerts.thswLessThanThreshold": "THSW mniejszy niż {value}{unit}",
  "alerts.thwGreaterThan": "THW większy niż",
  "alerts.thwGreaterThanThreshold": "THW większy niż {value}{unit}",
  "alerts.thwLessThan": "THW mniejszy niż",
  "alerts.thwLessThanThreshold": "THW mniejszy niż {value}{unit}",
  "alerts.triggerHistory": "Historia alertu",
  "alerts.uvGreaterThan": "UV Index większy niż",
  "alerts.uvGreaterThanThreshold": "UV Index większy niż {value}{unit}",
  "alerts.uvLessThan": "UV Index mniejszy niż",
  "alerts.uvLessThanThreshold": "UV Index mniejszy niż {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Widoczność większa niż {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Widoczność mniejsza niż {value}{unit}",
  "alerts.visiblityGreaterThan": "Widoczność większa niż",
  "alerts.visiblityLessThan": "Widoczność mniejsza niż",
  "alerts.whichMeasure": "O jakiej wielkości mierzonej chcesz być ostrzegany?",
  "alerts.whichModule": "Dla którego modułu chcesz otrzymywać alarmy?",
  "alerts.whichSensor": "Dla którego czujnika chcesz otrzymywać alarmy?",
  "alerts.windChillGreaterThan": "Chłód wiatru większy niż",
  "alerts.windChillGreaterThanThreshold": "Chłód wiatru większy niż {value}{unit}",
  "alerts.windChillLessThan": "Chłód wiatru mniejszy niż",
  "alerts.windChillLessThanThreshold": "Chłód wiatru mniejszy niż {value}{unit}",
  "alerts.windSpeedGreaterThan": "Prędkość wiatru większa niż",
  "alerts.windSpeedGreaterThanThreshold": "Prędkość wiatru większa niż {value}{unit}",
  "alerts.windSpeedLessThan": "Prędkość wiatru mniejsza niż",
  "alerts.windSpeedLessThanThreshold": "Prędkość wiatru mniejsza niż {value}{unit}",
  "appUpdate.updateAvailable": "Dostępna aktualizacja",
  "appUpdate.updateAvailableOpenAppStore": "Dotknij, aby otworzyć App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Dotknij, aby otworzyć Google Play",
  "appUpdate.updateAvailableVersion": "Dostępna aktualizacja: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Wymagana jest aktualizacja aplikacji, przejdź do Google Play, aby ją zaktualizować.",
  "appUpdate.upgradeRequiredIos": "Wymagana jest aktualizacja aplikacji, przejdź do App Store, aby ją zaktualizować.",
  "astral.aboveHorizonAllDay": "Cały dzień nad horyzontem",
  "astral.aboveTheHorizon": "nad horyzontem",
  "astral.apparentSize": "Rozmiar kątowy",
  "astral.apparentSizeAcross": "{size} średnicy",
  "astral.astronomicalDawn": "Świt astronomiczny",
  "astral.astronomicalDusk": "Zmierzch astronomiczny",
  "astral.belowHorizonAllDay": "Cały dzień pod horyzontem",
  "astral.belowHorizonSince": "Pod horyzontem od {time}",
  "astral.belowHorizonSinceOn": "Pod horyzontem od {day} {time}",
  "astral.brightAllNight": "Jasno przez całą noc — nigdy całkiem ciemno",
  "astral.brightestMoment": "Najjaśniejszy moment",
  "astral.civilDawn": "Świt cywilny",
  "astral.civilDusk": "Zmierzch cywilny",
  "astral.darkSkyBetween": "Ciemne niebo {from} → {to}",
  "astral.darkSkyWindow": "Ciemne niebo {from} → {to} · {duration} bez Księżyca",
  "astral.dayLength": "Długość dnia",
  "astral.daylightThroughTheYear": "Długość dnia w ciągu roku",
  "astral.dayOfCycle": "dzień {day} z {total}",
  "astral.doesNotOccurToday": "Dziś nie występuje",
  "astral.domeHint": "Przeciągnij, aby przejść przez noc",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Najwcześniejszy wschód słońca",
  "astral.earliestSunset": "Najwcześniejszy zachód słońca",
  "astral.equinox": "Równonoc",
  "astral.equinoxIn": "Równonoc za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.evening": "Wieczór",
  "astral.exactPhaseAt": "Dokładnie o {time}",
  "astral.firstQuarter": "Pierwsza kwadra",
  "astral.firstSunriseIn": "Pierwszy wschód słońca za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.firstSunsetIn": "Pierwszy zachód słońca za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.fullMoon": "Księżyc w pełni",
  "astral.goldenHourBegins": "Początek złotej godziny",
  "astral.goldenHourEnds": "Koniec złotej godziny",
  "astral.highestPoint": "Najwyższy punkt",
  "astral.inDays": "za {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "astral.lastQuarter": "Ostatnia kwadra",
  "astral.latestSunrise": "Najpóźniejszy wschód słońca",
  "astral.latestSunset": "Najpóźniejszy zachód słońca",
  "astral.litShort": "Oświetl.",
  "astral.longestDay": "Najdłuższy dzień",
  "astral.lowestPoint": "Najniższy punkt",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Południe",
  "astral.midnightSun": "Dzień polarny",
  "astral.midnightSunPeriod": "Dzień polarny",
  "astral.milestoneFootnotePolar": "Tutaj słońce przez {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}} w roku ani nie wschodzi, ani nie zachodzi, więc zamiast zwykłych skrajnych wschodów i zachodów lista pokazuje, kiedy to się dzieje.",
  "astral.milestoneFootnoteTemperate": "Najwcześniejszy zachód i najpóźniejszy wschód nie przypadają w najkrótszy dzień — te dwie daty wyznacza równanie czasu, a nie przesilenie.",
  "astral.moon": "Księżyc",
  "astral.moonAltitude": "Wysokość",
  "astral.moonDirection": "Azymut",
  "astral.moonDistance": "Odległość",
  "astral.moonlessFor": "{duration} bez Księżyca",
  "astral.moonPhases": "Fazy księżyca",
  "astral.moonrise": "Wschód księżyca",
  "astral.moonset": "Zachód księżyca",
  "astral.moonUpAllNight": "Księżyc jest nad horyzontem całą noc",
  "astral.moonWashesOutNight": "Księżyc jest nad horyzontem od {rise} do {set} i rozjaśnia całą noc",
  "astral.morning": "Rano",
  "astral.nauticalDawn": "Świt żeglarski",
  "astral.nauticalDusk": "Zmierzch żeglarski",
  "astral.newMoon": "Nów",
  "astral.nextDay": "+1 dzień",
  "astral.nextProperlyDarkNight": "Następna naprawdę ciemna noc",
  "astral.nextRise": "następny wschód o {time}",
  "astral.nextRiseOn": "następny wschód {day} o {time}",
  "astral.nextSevenNights": "Najbliższe siedem nocy",
  "astral.nightDate": "Data",
  "astral.noAstronomicalDarknessTonight": "Brak nocy astronomicznej dziś w nocy",
  "astral.noDarkNightAhead": "Żadnej w ciągu najbliższych dwóch tygodni",
  "astral.noStationLocation": "Nieznana lokalizacja",
  "astral.noStationLocationDescription": "Ta stacja nie ma zapisanego położenia, więc nie można dla niej obliczyć słońca i księżyca.",
  "astral.noSunriseToday": "Dziś słońce nie wschodzi",
  "astral.nowAtBearing": "teraz {altitude} · azymut {direction}",
  "astral.observing": "Obserwacje",
  "astral.ofDaylightLeft": "światła dziennego zostało",
  "astral.overTheNextThreeWeeks": "w ciągu najbliższych 3 tygodni",
  "astral.percentLit": "oświetlenie {percent}",
  "astral.polarNight": "Noc polarna",
  "astral.polarNightPeriod": "Noc polarna",
  "astral.rightNow": "Teraz",
  "astral.riseShort": "Wschód",
  "astral.setShort": "Zachód",
  "astral.shortestDay": "Najkrótszy dzień",
  "astral.solarNoon": "Południe słoneczne",
  "astral.solstice": "Przesilenie",
  "astral.sunBelowHorizon": "Słońce {degrees}° pod horyzontem",
  "astral.sunEvents": "Zdarzenia słoneczne",
  "astral.sunNeverDarkEnough": "Słońce nigdy nie schodzi 18° pod horyzont",
  "astral.sunNeverSets": "Słońce nie zachodzi",
  "astral.sunrise": "Wschód słońca",
  "astral.sunriseAndSunset": "Wschód i zachód słońca",
  "astral.sunriseAt": "Wschód słońca o {time}",
  "astral.sunset": "Zachód słońca",
  "astral.sunsetAt": "Zachód słońca o {time}",
  "astral.thisYearAtNorth": "W tym roku na {degrees}° szer. płn.",
  "astral.thisYearAtSouth": "W tym roku na {degrees}° szer. płd.",
  "astral.tonight": "Dziś w nocy",
  "astral.twilightAllNight": "Zmierzch przez całą noc — nigdy całkiem ciemno",
  "astral.upFor": "{duration} nad horyzontem",
  "astral.usableLight": "Użyteczne światło",
  "astral.vsAverage": "{percent} względem średniej",
  "astral.vsYesterday": "wzgl. wczoraj",
  "astral.waningCrescent": "Ubywający sierp",
  "astral.waningGibbous": "Ubywający garb",
  "astral.waxingCrescent": "Przybywający sierp",
  "astral.waxingGibbous": "Przybywający garb",
  "astral.whereToLook": "Gdzie patrzeć",
  "astral.withoutTheMoon": "{duration} bez Księżyca",
  "auth.alreadyHaveAccount": "Masz już konto?",
  "auth.authContainerTagline": "Twój osobisty panel pogodowy. Połącz swoje stacje i uzyskaj dane w czasie rzeczywistym na wyciągnięcie ręki.",
  "auth.backToLogin": "Powrót do logowania",
  "auth.checkYourEmail": "Sprawdź swój e-mail",
  "auth.continueWithApple": "Kontynuuj z Apple",
  "auth.continueWithFacebook": "Kontynuuj z Facebook",
  "auth.continueWithGoogle": "Kontynuuj z Google",
  "auth.email": "Adres e-mail",
  "auth.emailRequiredLoginFacebook": "Uprawnienie do korzystania z poczty e-mail jest wymagane do logowania się przez Facebook",
  "auth.emailVerification": "Weryfikacja adresu e-mail",
  "auth.emailVerificationFailure": "Wystąpił problem z weryfikacją adresu e-mail.",
  "auth.emailVerificationSuccess": "Twój email został poprawnie zweryfikowany",
  "auth.firstName": "Imię",
  "auth.forgotPassword": "Zapomniałeś hasła?",
  "auth.forgotPasswordSubtitle": "Podaj swój adres e-mail, a wyślemy Ci link do zresetowania hasła.",
  "auth.lastName": "Nazwisko",
  "auth.login": "Zaloguj się",
  "auth.loginSubtitle": "Witamy ponownie! Proszę podać swoje dane.",
  "auth.loginToSmartMixinDescription": "Zaloguj się do SmartMixin, aby uzyskać dostęp do swoich stacji pogodowych, przeglądać analizy i zarządzać osobistym panelem pogodowym.",
  "auth.logout": "Wyloguj się",
  "auth.logoutConfirmation": "Czy chcesz się wylogować?",
  "auth.noAccountYet": "Nie masz jeszcze konta?",
  "auth.or": "lub",
  "auth.password": "Hasło",
  "auth.passwordReset": "Reset hasła",
  "auth.passwordResetSuccess": "Twoje hasło zostało pomyślnie zaktualizowane.",
  "auth.register": "Utwórz konto",
  "auth.registerDescription": "Utwórz bezpłatne konto SmartMixin, aby połączyć swoje stacje pogodowe, śledzić dane pogodowe i korzystać z zaawansowanych narzędzi analitycznych.",
  "auth.registerSubtitle": "Utwórz konto, aby rozpocząć.",
  "auth.restorePassword": "Przywróć hasło",
  "auth.restorePasswordSuccess": "Właśnie wysłaliśmy Ci link do resetowania hasła na {emailAddress} z dalszymi instrukcjami.",
  "auth.sendReset": "Wyślij instrukcje resetowania",
  "auth.signInWithApple": "Zaloguj się przez Apple",
  "auth.socialAccount": "lub użyj swojego konta społecznościowego",
  "auth.staffVerificationCode": "Kod weryfikacyjny",
  "auth.staffVerificationExpiresIn": "Zweryfikowano. Wygasa za {duration}.",
  "auth.staffVerificationInvalidCode": "Nieprawidłowy kod. Spróbuj ponownie.",
  "auth.staffVerificationLoginAsStopped": "Login As został zatrzymany: aby kontynuować, wpisz kod weryfikacyjny na ekranie Debug.",
  "auth.staffVerificationNotEnrolled": "Dla Twojego konta nie skonfigurowano aplikacji uwierzytelniającej. Dodaj ją w ustawieniach zabezpieczeń panelu administracyjnego.",
  "auth.staffVerificationPrompt": "Wpisz 6-cyfrowy kod z aplikacji uwierzytelniającej lub kod odzyskiwania, aby korzystać z Login As i wyszukiwania użytkowników.",
  "auth.staffVerificationSetupLink": "Dodaj aplikację uwierzytelniającą",
  "auth.staffVerificationSubmit": "Zweryfikuj",
  "auth.staffVerificationTitle": "Weryfikacja personelu",
  "calendar.afternoon": "Popołudnie",
  "calendar.april": "Kwiecień",
  "calendar.august": "Sierpień",
  "calendar.changePeriod": "Okres: {period}. Zmień okres",
  "calendar.currentDay": "Dzisiaj",
  "calendar.dateFormat": "Format daty",
  "calendar.day": "Dzień",
  "calendar.december": "Grudzień",
  "calendar.durationHours": "{hours} godz.",
  "calendar.durationHoursMinutes": "{hours} godz. {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Wcześniejsze lata",
  "calendar.endTime": "Koniec",
  "calendar.evening": "Wieczór",
  "calendar.february": "Luty",
  "calendar.goToNextDay": "Następny dzień",
  "calendar.goToNextMonth": "Następny miesiąc",
  "calendar.goToNextWeek": "Następny tydzień",
  "calendar.goToNextYear": "Następny rok",
  "calendar.goToPreviousDay": "Poprzedni dzień",
  "calendar.goToPreviousMonth": "Poprzedni miesiąc",
  "calendar.goToPreviousWeek": "Poprzedni tydzień",
  "calendar.goToPreviousYear": "Poprzedni rok",
  "calendar.hour": "Godzina",
  "calendar.hoursCount": "{count, plural, one {# godzina} few {# godziny} many {# godzin} other {# godziny}}",
  "calendar.hoursShort": "godz.",
  "calendar.hoursShortCount": "{count, plural, one {# godz.} few {# godz.} many {# godz.} other {# godz.}}",
  "calendar.january": "Styczeń",
  "calendar.july": "Lipiec",
  "calendar.june": "Czerwiec",
  "calendar.last12Hours": "Ostatnie 12 godzin",
  "calendar.last24Hours": "Ostatnie 24 godziny",
  "calendar.last30Days": "Ostatnie 30 dni",
  "calendar.last3Hours": "Ostatnie 3 godziny",
  "calendar.last6Hours": "Ostatnie 6 godzin",
  "calendar.last7Days": "Ostatnie 7 dni",
  "calendar.lastHour": "Ostatnia godzina",
  "calendar.laterYears": "Późniejsze lata",
  "calendar.march": "Marzec",
  "calendar.max": "Max",
  "calendar.may": "Maj",
  "calendar.month": "Miesiąc",
  "calendar.monthTotal": "Ten miesiąc",
  "calendar.morning": "Rano",
  "calendar.nextHours": "Następne godziny",
  "calendar.night": "Noc",
  "calendar.november": "Listopad",
  "calendar.october": "Październik",
  "calendar.oneDay": "1 dzień",
  "calendar.oneHour": "1 godzina",
  "calendar.oneMonth": "1 miesiąc",
  "calendar.oneWeek": "1 tydzień",
  "calendar.periodRangeSpoken": "od {start} do {end}",
  "calendar.previous24Hours": "Poprzednie 24 godziny",
  "calendar.previous30Days": "Poprzednie 30 dni",
  "calendar.previous7Days": "Poprzednie 7 dni",
  "calendar.previousDay": "Poprzedni dzień",
  "calendar.previousHours": "Poprzednie godziny",
  "calendar.previousMonth": "Poprzedni miesiąc",
  "calendar.previousWeek": "Poprzedni tydzień",
  "calendar.previousYear": "Poprzedni rok",
  "calendar.sameDayLastYear": "Ten sam dzień w zeszłym roku",
  "calendar.sameMonthLastYear": "Ten sam miesiąc w zeszłym roku",
  "calendar.selectADate": "Wybierz datę",
  "calendar.selectAggregation": "Wybierz wyświetlaną wartość",
  "calendar.selectAMonth": "Wybierz miesiąc",
  "calendar.selectAYear": "Wybierz rok",
  "calendar.selectGranularity": "Wybierz szczegółowość",
  "calendar.selectPeriod": "Wybierz okres",
  "calendar.september": "Wrzesień",
  "calendar.sixHours": "6 godzin",
  "calendar.startTime": "Początek",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 godziny",
  "calendar.timezone": "Strefa czasowa",
  "calendar.today": "Dzisiaj",
  "calendar.untilChanged": "Do czasu zmiany",
  "calendar.untilTime": "Do {time}",
  "calendar.untilTodayAt": "Dziś do {time}",
  "calendar.untilTomorrowAt": "Jutro do {time}",
  "calendar.use24HourFormat": "Użyj formatu 24h",
  "calendar.week": "Tydzień",
  "calendar.year": "Rok",
  "calendar.yearToDate": "W tym roku",
  "calendar.yesterday": "Wczoraj",
  "charts.averageOverThePeriod": "Średnia w okresie",
  "charts.calendarView": "Widok kalendarza",
  "charts.charts": "Wykresy",
  "charts.chartView": "Widok wykresu",
  "charts.comparison": "Porównanie",
  "charts.customizeComparisonMetrics": "Dostosuj metryki",
  "charts.customizeComparisonMetricsDescription": "Przeciągnij elementy, aby zmienić kolejność metryk porównania. Dotknij ikony oka, aby pokazać lub ukryć metryki.",
  "charts.loading": "Wczytywanie wykresu",
  "charts.maxOverThePeriod": "Maksimum w okresie",
  "charts.measureToDisplay": "Pomiar do wyświetlenia",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Brak danych za ten okres",
  "charts.observations": "Pomiary",
  "charts.observedTemperature": "Zmierzona temperatura",
  "charts.seriesTableDate": "Data",
  "charts.showComparison": "Pokaż porównanie",
  "charts.stationComparison": "Porównanie stacji",
  "charts.stationComparisonDescription": "Porównaj historyczne dane pogodowe z inną stacją",
  "charts.sumOverThePeriod": "Suma za okres",
  "charts.tableLabel": "Tabela: {chart}",
  "charts.toggleSeries": "Pokaż lub ukryj: {series}",
  "charts.viewAsChart": "Wykres",
  "charts.viewAsList": "Lista",
  "charts.viewAsPeriods": "Pory dnia",
  "charts.viewAsTable": "Tabela",
  "charts.viewLabel": "Widok: {chart}",
  "common.add": "Dodaj",
  "common.altitude": "Wysokość",
  "common.analysis": "Analiza",
  "common.average": "Średnia",
  "common.back": "Wstecz",
  "common.backToHome": "Powrót do strony głównej",
  "common.cancel": "Anuluj",
  "common.cannotBeEmpty": "To pole nie może być puste.",
  "common.close": "Zamknij",
  "common.dailyForecast": "Pogoda dzienna",
  "common.default": "Domyślny",
  "common.delete": "Usuń",
  "common.details": "Szczegóły",
  "common.edit": "Edytuj",
  "common.exitFullscreen": "Zamknij pełny ekran",
  "common.forecast": "Prognoza",
  "common.frequency": "Częstotliwość",
  "common.full": "Pełny",
  "common.fullscreen": "Pełny ekran",
  "common.help": "Pomoc",
  "common.hidden": "Ukryte",
  "common.high": "Wysoki",
  "common.iDontKnowYet": "Jeszcze nie wiem",
  "common.indoor": "Wewnątrz",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Ostatnia aktualizacja",
  "common.low": "Niski",
  "common.maximum": "Maksimum",
  "common.medium": "Średni",
  "common.minimum": "Minimum",
  "common.more": "Więcej",
  "common.moreInformation": "Więcej informacji",
  "common.next": "Dalej",
  "common.no": "Nie",
  "common.noAccountNeeded": "Konto nie jest wymagane",
  "common.noItemsAvailable": "Brak dostępnych elementów",
  "common.notNow": "Nie teraz",
  "common.now": "Teraz",
  "common.openSettings": "Otwórz ustawienia",
  "common.outdoor": "Na zewnątrz",
  "common.pageNotFound": "Strona nie znaleziona",
  "common.pageNotFoundDescription": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
  "common.rain": "Deszcz",
  "common.reorderCancel": "Anulowano przenoszenie: {item}. Powrót na pozycję {position} z {count}.",
  "common.reorderEnd": "Upuszczono: {item}. Pozycja {position} z {count}.",
  "common.reorderInstructions": "Aby przenieść ten element, naciśnij spację lub Enter, wybierz jego miejsce strzałkami w górę i w dół, a następnie ponownie naciśnij spację lub Enter, aby go upuścić, albo Escape, aby anulować.",
  "common.reorderOver": "{item} – teraz pozycja {position} z {count}.",
  "common.reorderStart": "Podniesiono: {item}. Pozycja {position} z {count}.",
  "common.share": "Udostępnij",
  "common.shareImageFailed": "Nie udało się udostępnić obrazu",
  "common.shareYourWeather": "Udostępnij swoją pogodę",
  "common.skip": "Pomiń",
  "common.start": "Start",
  "common.unknown": "Nieznany",
  "common.validate": "Potwierdź",
  "common.validEmail": "Wymagany jest prawidłowy adres e-mail.",
  "common.very_low": "Bardzo niski",
  "common.weatherObservations": "Obserwacje pogodowe",
  "common.welcome": "Witamy w SmartMixin!",
  "common.wind": "Wiatr",
  "common.yes": "Tak",
  "common.zoomImage": "Powiększ obraz",
  "compass.E": "E",
  "compass.E_long": "Wschód",
  "compass.ENE": "ENE",
  "compass.ENE_long": "Wschód-północny wschód",
  "compass.ESE": "ESE",
  "compass.ESE_long": "Wschód-południowy wschód",
  "compass.N": "N",
  "compass.N_long": "Północ",
  "compass.NE": "NE",
  "compass.NE_long": "Północny wschód",
  "compass.NNE": "NNE",
  "compass.NNE_long": "Północ-północny wschód",
  "compass.NNW": "NNW",
  "compass.NNW_long": "Północ-północny zachód",
  "compass.NW": "NW",
  "compass.NW_long": "Północny zachód",
  "compass.S": "S",
  "compass.S_long": "Południe",
  "compass.SE": "SE",
  "compass.SE_long": "Południowy wschód",
  "compass.SSE": "SSE",
  "compass.SSE_long": "Południe-południowy wschód",
  "compass.SSW": "SSW",
  "compass.SSW_long": "Południe-południowy zachód",
  "compass.SW": "SW",
  "compass.SW_long": "Południowy zachód",
  "compass.W": "W",
  "compass.W_long": "Zachód",
  "compass.WNW": "WNW",
  "compass.WNW_long": "Zachód-północny zachód",
  "compass.WSW": "WSW",
  "compass.WSW_long": "Zachód-południowy zachód",
  "dashboard.currentObservations": "Aktualne dane pomiarowe",
  "dashboard.currentRainEvent": "Bieżące zdarzenie deszczowe",
  "dashboard.currentWeatherConditions": "Aktualne warunki pogodowe",
  "dashboard.customizeDashboard": "Dostosuj",
  "dashboard.customizeDashboardDescription": "Przeciągnij elementy, aby zmienić kolejność na pulpicie. Dotknij ikony oka, aby pokazać lub ukryć sekcje.",
  "dashboard.dashboard": "Ogólne",
  "dashboard.dayRangeExpected": "{value} oczekiwane o {time}",
  "dashboard.dayRangeReached": "{value} o {time}",
  "dashboard.dayRangeSteady": "Stabilnie {value} przez cały dzień",
  "dashboard.hiddenSensors": "Ukryte czujniki",
  "dashboard.hideSensor": "Ukryj: {sensor}",
  "dashboard.lastRainEvent": "Ostatnie zdarzenie deszczowe",
  "dashboard.lastVisibleSensor": "Co najmniej jeden czujnik musi pozostać widoczny.",
  "dashboard.manageSensors": "Zarządzaj czujnikami",
  "dashboard.manageSensorsDescription": "Przeciągnij elementy, aby zmienić kolejność czujników. Dotknij ikony oka, aby pokazać lub ukryć czujniki. Dotknij nazwy, aby ją zmienić.",
  "dashboard.manageSensorsDescriptionWeb": "Kliknij ołówek, aby zmienić nazwę czujnika, przeciągnij uchwyt, aby zmienić kolejność listy, i kliknij oko, aby go ukryć lub pokazać.",
  "dashboard.moveSensor": "Przenieś: {sensor}",
  "dashboard.pressureSummary": "Podsumowanie ciśnienia",
  "dashboard.rainEvents": "Zdarzenia deszczowe",
  "dashboard.rainSummary": "Podsumowanie opadów",
  "dashboard.renameSensor": "Zmień nazwę: {sensor}",
  "dashboard.shareOutdoorMeasures": "Udostępnij pomiary zewnętrzne",
  "dashboard.shareOutdoorMeasuresDescription": "Dołącz do społeczności SmartMixin, udostępniając innym swoje pomiary zewnętrzne. Pomiary wewnętrzne nigdy nie będą udostępniane.",
  "dashboard.showSensor": "Pokaż: {sensor}",
  "dashboard.temperatureSummary": "Podsumowanie temperatury",
  "dashboard.useDefaultSensorName": "Użyj nazwy domyślnej",
  "dashboard.windSummary": "Podsumowanie wiatru",
  "devices.batteryLevel": "Poziom naładowania baterii",
  "devices.firmwareVersion": "Wersja oprogramowania",
  "devices.moduleCount": "{count, plural, one {# moduł} few {# moduły} many {# modułów} other {# modułu}}",
  "devices.moduleType": "Typ modułu",
  "devices.noNetatmoWeatherStationYet": "Nie masz jeszcze stacji meteorologicznej Netatmo.",
  "devices.noOutdoorModule": "Dla tej stacji nie ma działającego modułu zewnętrznego.",
  "devices.notReachable": "Brak łączności",
  "devices.serialNumber": "Numer seryjny",
  "devices.signalAverage": "Średni",
  "devices.signalBad": "Słaby",
  "devices.signalGood": "Dobry",
  "devices.signalStrength": "Siła sygnału",
  "devices.signalUnknown": "Nieznany",
  "devices.visitNetatmoWebsite": "Odwiedź stronę Netatmo",
  "devices.wifiStrength": "Siła Wi-Fi",
  "forecastMaps.addColor": "Dodaj kolor",
  "forecastMaps.addLayer": "Dodaj warstwę",
  "forecastMaps.autoDescription": "Najlepszy dostępny dla tego widoku",
  "forecastMaps.autoDescriptionFree": "Konta bezpłatne korzystają z modelu {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Teraz {model}: {previous} obejmuje {coverage, number, percent} tego widoku",
  "forecastMaps.backToMaps": "Powrót do map",
  "forecastMaps.build": "Generuj",
  "forecastMaps.buildCompleted": "Generowanie zakończone",
  "forecastMaps.builderMetaDescription": "Twórz własne mapy prognoz z warstw modeli pogodowych.",
  "forecastMaps.builderTitle": "Kreator map",
  "forecastMaps.buildFailed": "Generowanie nie powiodło się. Spróbuj ponownie.",
  "forecastMaps.buildNotPossible": "Tej mapy nie można jeszcze wygenerować — brak dostępnych danych prognostycznych.",
  "forecastMaps.buildProgress": "Renderowanie… {completed}/{total} kroków",
  "forecastMaps.buildStarting": "Rozpoczynanie generowania…",
  "forecastMaps.byModel": "Według modelu",
  "forecastMaps.byZone": "Według strefy",
  "forecastMaps.colormap": "Skala kolorów",
  "forecastMaps.colormapCustom": "Własne kolory",
  "forecastMaps.colormapGroupDomain": "Zestawy pogodowe",
  "forecastMaps.colormapGroupMatplotlib": "Zestawy naukowe",
  "forecastMaps.colorStop": "Kolor {position}",
  "forecastMaps.configUnavailable": "Ta mapa prognozy jest niedostępna. Zamiast niej wyświetlana jest mapa {name}.",
  "forecastMaps.contourLevels": "Poziomy izolinii",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francja",
  "forecastMaps.countryGermany": "Niemcy",
  "forecastMaps.countryItaly": "Włochy",
  "forecastMaps.countryScandinavia": "Skandynawia",
  "forecastMaps.countrySpain": "Hiszpania",
  "forecastMaps.countrySwitzerland": "Szwajcaria",
  "forecastMaps.countryUnitedStates": "Stany Zjednoczone",
  "forecastMaps.coverageUnknown": "Obszar nieznany",
  "forecastMaps.coversView": "Obejmuje {coverage, number, percent} tego widoku",
  "forecastMaps.customColormapMinColors": "Własna skala kolorów wymaga co najmniej dwóch kolorów",
  "forecastMaps.customExtent": "Własny zasięg",
  "forecastMaps.displayName": "Wyświetlana nazwa",
  "forecastMaps.downscaling": "Współczynnik przerzedzenia chorągiewek",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Narysuj obszar",
  "forecastMaps.east": "Wschód",
  "forecastMaps.extentDrawHint": "Przeciągnij po mapie, aby narysować obszar",
  "forecastMaps.extentInvalid": "Zachód musi być mniejszy niż wschód, a południe mniejsze niż północ",
  "forecastMaps.frameTime": "Czas prognozy",
  "forecastMaps.height": "Wysokość (cale)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "Na tym obszarze",
  "forecastMaps.invalidHexColor": "Nieprawidłowy kolor — użyj #RRGGBB",
  "forecastMaps.layerHasErrors": "Ta warstwa zawiera błędy",
  "forecastMaps.layers": "Warstwy",
  "forecastMaps.layerTypeBarbs": "Chorągiewki wiatru",
  "forecastMaps.layerTypeContour": "Izolinie",
  "forecastMaps.layerTypeFilledContour": "Wypełnione izolinie",
  "forecastMaps.layerTypeMagnitude": "Wielkość",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Pole wektorowe",
  "forecastMaps.leave": "Wyjdź",
  "forecastMaps.levelsCount": "Liczba",
  "forecastMaps.levelsInvalid": "Nieprawidłowe poziomy izolinii",
  "forecastMaps.levelsModeArange": "Stały krok",
  "forecastMaps.levelsModeExplicit": "Jawne wartości",
  "forecastMaps.levelsModeLinspace": "Równomiernie rozłożone (liczba)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Wartości",
  "forecastMaps.levelsValuesHint": "Rozdzielone przecinkami, rosnąco",
  "forecastMaps.loadingMaps": "Wczytywanie map…",
  "forecastMaps.localTimeHint": "Wyświetlane w Twoim czasie lokalnym",
  "forecastMaps.lockedConfig": "{model} to model Premium. Zamiast niego wyświetlany jest {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Opis",
  "forecastMaps.mapName": "Nazwa mapy",
  "forecastMaps.mapNameRequired": "Wpisz nazwę",
  "forecastMaps.mapSettings": "Ustawienia mapy",
  "forecastMaps.maxLayersReached": "Ta mapa osiągnęła maksimum {max} warstw.",
  "forecastMaps.maxValue": "Wartość maksymalna",
  "forecastMaps.memoryBudgetExceeded": "Rozdzielczość przekracza budżet renderowania — zmniejsz DPI lub wysokość",
  "forecastMaps.memoryBudgetUsage": "Budżet renderowania: {percent}%",
  "forecastMaps.metaDescription": "Animowane mapy prognoz generowane z przebiegów modeli pogodowych.",
  "forecastMaps.metric": "Parametr",
  "forecastMaps.metricRequired": "Wybierz parametr",
  "forecastMaps.metricUnavailable": "Niedostępny dla tego modelu",
  "forecastMaps.minBelowMax": "Minimum musi być mniejsze niż maksimum",
  "forecastMaps.minMaxRequired": "Wartości minimalna i maksymalna są wymagane dla tego typu warstwy",
  "forecastMaps.minValue": "Wartość minimalna",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} obejmuje {coverage, number, percent} tego widoku",
  "forecastMaps.modelNoRun": "Brak ukończonego przebiegu",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Przesuń w dół",
  "forecastMaps.moveLayerUp": "Przesuń w górę",
  "forecastMaps.nanClipToMin": "Ogranicz do minimum",
  "forecastMaps.nanMask": "Maskuj",
  "forecastMaps.nanPolicy": "Brakujące dane",
  "forecastMaps.nanSkip": "Pomiń",
  "forecastMaps.noCompletedRun": "Ta mapa nie została jeszcze wygenerowana. Sprawdź ponownie wkrótce.",
  "forecastMaps.noLayers": "Brak warstw. Dodaj warstwę, aby rozpocząć.",
  "forecastMaps.noMapsAvailable": "Mapy prognoz nie są jeszcze dostępne.",
  "forecastMaps.north": "Północ",
  "forecastMaps.opacity": "Krycie",
  "forecastMaps.openAsAnimation": "Otwórz jako animację",
  "forecastMaps.otherAreas": "Inne obszary",
  "forecastMaps.outsideArea": "Nie obejmuje tego obszaru",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauza",
  "forecastMaps.play": "Odtwórz",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Nie udało się wczytać prognozy dla tego punktu.",
  "forecastMaps.pointValueLoading": "Wczytywanie prognozy…",
  "forecastMaps.pointValueUnavailable": "Brak danych dla tej godziny.",
  "forecastMaps.premiumModelForView": "{model} obejmuje ten widok",
  "forecastMaps.premiumRequired": "Mapy prognoz wymagają Premium",
  "forecastMaps.preview": "Podgląd",
  "forecastMaps.previewEmptyHint": "Skonfiguruj co najmniej jedną prawidłową warstwę, aby wyrenderować podgląd.",
  "forecastMaps.previewFailed": "Podgląd nie powiódł się",
  "forecastMaps.previewHour": "Godzina prognozy",
  "forecastMaps.previewRendering": "Renderowanie podglądu…",
  "forecastMaps.projection": "Odwzorowanie",
  "forecastMaps.projectionLambertConformal": "Lamberta wiernokątne",
  "forecastMaps.projectionMercator": "Merkatora",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereograficzne",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Ameryka Północna",
  "forecastMaps.removeColor": "Usuń kolor",
  "forecastMaps.removeLayer": "Usuń warstwę",
  "forecastMaps.retry": "Spróbuj ponownie",
  "forecastMaps.run": "Przebieg: {run}",
  "forecastMaps.runNotDisplayable": "Tego przebiegu nie można wyświetlić na mapie interaktywnej.",
  "forecastMaps.save": "Zapisz",
  "forecastMaps.selectExtentOnMap": "Wybierz obszar na mapie",
  "forecastMaps.showArea": "Pokaż obszar",
  "forecastMaps.showAreaOf": "Pokaż obszar, {model}",
  "forecastMaps.south": "Południe",
  "forecastMaps.switchToModel": "Przełącz na {model}",
  "forecastMaps.title": "Mapy prognoz",
  "forecastMaps.uMetric": "Składowa U",
  "forecastMaps.unitConversion": "Konwersja jednostek",
  "forecastMaps.unitNone": "Brak",
  "forecastMaps.unsavedChangesBody": "Masz niezapisane zmiany. Wyjść i je odrzucić?",
  "forecastMaps.unsavedChangesTitle": "Niezapisane zmiany",
  "forecastMaps.useCurrentView": "Użyj bieżącego widoku",
  "forecastMaps.useModelDomain": "Wyłączone: używany jest pełny obszar modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Parametry U i V muszą się różnić",
  "forecastMaps.valueAtMapCentre": "Wartość na środku mapy",
  "forecastMaps.valueBetween": "Musi być między {min} a {max}",
  "forecastMaps.variable": "Zmienna",
  "forecastMaps.variableMissing": "{variable}: brak danych",
  "forecastMaps.variableOnlyFrom": "{variable} pochodzi tylko z {model}",
  "forecastMaps.viewMap": "Zobacz mapę",
  "forecastMaps.vMetric": "Składowa V",
  "forecastMaps.west": "Zachód",
  "forecastMaps.windAnimation": "Animacja wiatru",
  "forecastModels.addForecastModel": "Dodaj model",
  "forecastModels.atYourStations": "Dostępne na Twoich stacjach",
  "forecastModels.comparisonLoadError": "Nie udało się wczytać porównania modeli pogody",
  "forecastModels.coverageLoading": "Ustalanie, które z Twoich stacji obejmuje każdy model…",
  "forecastModels.description_AROME": "Wysokorozdzielczy model Météo France z rozwiązywaniem konwekcji nad Europą Zachodnią o rozdzielczości 1,3 km. Najlepszy w swojej klasie do krótkoterminowych prognoz we Francji; aktualizowany co trzy godziny.",
  "forecastModels.description_ARPEGE_EU": "Europejska domena zagnieżdżona modelu ARPEGE Météo France o rozdzielczości 10 km. Średnioterminowe prognozy dla Europy, aktualizowane cztery razy dziennie.",
  "forecastModels.description_ARPEGE_GLOBAL": "Globalny numeryczny model pogody Météo France o rozdzielczości 25 km, działający do około 4 dni. Aktualizowany cztery razy dziennie.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI od DMI: model rozwiązujący konwekcję nad Europą Północno-Zachodnią — Dania, Beneluks, Irlandia, Wielka Brytania i Skandynawia — o rozdzielczości 2 km działający do 60 godzin, aktualizowany osiem razy dziennie. Zawiera zmodyfikowane otwarte dane DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System od Environment Canada: ogólnoświatowy model średnioterminowy o rozdzielczości 15 km działający do 10 dni, aktualizowany dwa razy dziennie.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System od Environment Canada: model rozwiązujący konwekcję nad Kanadą i północną częścią Stanów Zjednoczonych o rozdzielczości 2,5 km działający do 48 godzin, aktualizowany cztery razy dziennie.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System od Environment Canada: model średnioterminowy nad Ameryką Północną o rozdzielczości 10 km, aktualizowany cztery razy dziennie.",
  "forecastModels.description_ECMWF_HRES": "Flagowy model wysokiej rozdzielczości (IFS) Europejskiego Centrum Prognoz Średnioterminowych, powszechnie uznawany za najlepszy globalny system prognozowania na świecie. Obejmuje całą planetę w rozdzielczości 25 km do 15 dni, aktualizowany cztery razy dziennie. Zawiera zmodyfikowane otwarte dane ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Flagowy średnioterminowy globalny model NOAA. Obejmuje całą planetę z rozdzielczością 25 km do 16 dni, aktualizowany cztery razy dziennie.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh NOAA: model z rozwiązywaniem konwekcji nad kontynentalnymi Stanami Zjednoczonymi o rozdzielczości 3 km, aktualizowany co godzinę. Najlepiej nadaje się do bardzo krótkoterminowych prognoz burz i ekstremalnej pogody.",
  "forecastModels.description_ICON": "Globalny model ICON od DWD o rozdzielczości 13 km obejmujący całą planetę do 7,5 dnia, aktualizowany cztery razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I od ItaliaMeteo, prowadzony wspólnie z ARPAE: model rozwiązujący konwekcję nad Włochami o rozdzielczości 2,2 km działający do 72 godzin, aktualizowany dwa razy dziennie. Zawiera otwarte dane ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Przebieg kontrolny ICON-CH1-EPS od MeteoSwiss: model rozwiązujący konwekcję nad Alpami o rozdzielczości 1 km działający do 33 godzin, aktualizowany co trzy godziny.",
  "forecastModels.description_ICON_CH2": "Przebieg kontrolny ICON-CH2-EPS od MeteoSwiss: model rozwiązujący konwekcję nad Alpami — Szwajcaria i otaczający region alpejski — o rozdzielczości 2,1 km działający do 120 godzin, aktualizowany cztery razy dziennie.",
  "forecastModels.description_ICON_DE": "Wysokorozdzielczy model DWD z rozwiązywaniem konwekcji nad Niemcami i krajami sąsiednimi o rozdzielczości 2,2 km. Krótkoterminowe prognozy aktualizowane dwa razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Europejska domena zagnieżdżona modelu ICON DWD o rozdzielczości 7 km obejmująca Europę i Atlantyk Północny. Średnioterminowe prognozy aktualizowane cztery razy dziennie. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Otwarta usługa prognozowania pogody Norweskiego Instytutu Meteorologicznego, łącząca wysokorozdzielcze modele nordyckie z danymi ECMWF, aby zapewnić ogólnoświatowe prognozy z wyprzedzeniem do 10 dni.",
  "forecastModels.description_MF_AROME_ANTILLES": "Zagnieżdżona domena AROME nad francuskimi Antylami (Gwadelupa, Martynika) o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "forecastModels.description_MF_AROME_GUYANE": "Zagnieżdżona domena AROME nad Gujaną Francuską o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Zagnieżdżona domena AROME nad Nową Kaledonią o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Zagnieżdżona domena AROME nad Polinezją Francuską o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Zagnieżdżona domena AROME nad Réunion i Majottą o rozdzielczości 2,5 km. Krótkoterminowe prognozy aktualizowane cztery razy dziennie.",
  "forecastModels.description_RRFS_CONUS": "System Rapid Refresh Forecast NOAA nad kontynentalnymi Stanami Zjednoczonymi w rozdzielczości 3 km. Prognozy godzinowe odświeżane osiem razy dziennie, do 84 godzin w czterech głównych przebiegach i 18 godzin w pozostałych.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "System Rapid Refresh Forecast NOAA obejmujący całą Amerykę Północną w rozdzielczości 13 km. Prognozy godzinowe do 84 godzin, odświeżane cztery razy dziennie.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Flagowa prognoza SmartMixin. Dla każdej godziny w Twojej lokalizacji wybieramy najlepszy dostępny model — zazwyczaj wysokorozdzielczy model regionalny tam, gdzie taki istnieje (AROME we Francji, ICON-D2 w Niemczech, HRRR w USA, ARPEGE Europe na całym kontynencie…) i w innych miejscach wracamy do modelu globalnego — następnie uzupełniamy wszelkie luki ze źródeł sąsiednich. Wynikiem jest jedna płynna prognoza obejmująca dowolne miejsce na świecie do 14 dni, automatycznie odświeżana za każdym razem, gdy aktualizowany jest którykolwiek z podstawowych modeli.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Zastrzeżona globalna prognoza Weatherflow, która łączy wiele numerycznych modeli pogody z obserwacjami z jej sieci stacji pogodowych Tempest. 10-dniowy globalny horyzont.",
  "forecastModels.everywhereElse": "Wszędzie indziej",
  "forecastModels.everywhereElseFoot": "Używany na każdej stacji, której nie obejmują Twoje preferowane modele.",
  "forecastModels.everywhereElsePick": "Wybierz jeden",
  "forecastModels.fallbackBlend": "Mieszanka SmartMixin",
  "forecastModels.fallbackBlendSub": "Łączy kilka modeli, każdy tam, gdzie jest najlepszy.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES wszędzie tam, gdzie sięga.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Globalny model NOAA. To, czego dziś używa każde konto.",
  "forecastModels.fallbackResolution": "Najwyższa rozdzielczość",
  "forecastModels.fallbackResolutionSub": "Najgęstsza siatka dostępna na każdej stacji.",
  "forecastModels.forecastChipLabelWithRun": "{model}, przebieg {run}",
  "forecastModels.forecastChipRunHint": "Przytrzymaj, aby pokazać lub ukryć najnowszy przebieg",
  "forecastModels.forecastComparisonDescription": "Łatwe porównywanie modeli pogody z różnych serwisów",
  "forecastModels.forecastFollowingPreferences": "Zgodnie z Twoimi preferencjami",
  "forecastModels.forecastLoadError": "Nie udało się wczytać prognozy",
  "forecastModels.forecastModel": "Model prognozy",
  "forecastModels.forecastModelAbout": "O modelu {model}",
  "forecastModels.forecastModelComparison": "Porównywanie modeli pogody",
  "forecastModels.forecastModelCoverage": "Zasięg",
  "forecastModels.forecastModelDescription": "Opis",
  "forecastModels.forecastModels": "Modele prognozy",
  "forecastModels.forecastModelScopeGlobal": "Globalny",
  "forecastModels.forecastModelScopeGlobalDescription": "Ten model obejmuje całą planetę.",
  "forecastModels.forecastModelScopeRegional": "Regionalny",
  "forecastModels.forecastModelScopeRegionalDescription": "Ten model obejmuje tylko określony region.",
  "forecastModels.forecastModelSpecifications": "Specyfikacja",
  "forecastModels.forecastNoPinLocation": "Żaden preferowany model nie obejmuje tej lokalizacji — decyduje „wszędzie indziej”.",
  "forecastModels.forecastNoPinStation": "Żaden preferowany model nie obejmuje tej stacji — decyduje „wszędzie indziej”.",
  "forecastModels.forecastNoPreferredModels": "Nie ustawiono jeszcze preferowanych modeli.",
  "forecastModels.forecastOverrideElsewhere": "Twoje preferencje obowiązują wszędzie indziej.",
  "forecastModels.forecastPickForLocation": "Albo wybierz jeden dla tej lokalizacji",
  "forecastModels.forecastPickForStation": "Albo wybierz jeden dla tej stacji",
  "forecastModels.forecastPinWinsLocation": "{model} — pierwszy preferowany model, który obejmuje tę lokalizację.",
  "forecastModels.forecastPinWinsStation": "{model} — pierwszy preferowany model, który obejmuje tę stację.",
  "forecastModels.forecastServedNowHere": "W tej chwili jest tu {model}",
  "forecastModels.forecastSetForLocation": "Ustawiono dla tej lokalizacji",
  "forecastModels.forecastSetForStation": "Ustawiono dla tej stacji",
  "forecastModels.forecastSettingsRowSub": "Preferowane modele i co obowiązuje wszędzie indziej",
  "forecastModels.forecastStopUsingHere": "Nie używaj tutaj",
  "forecastModels.forecastUseForLocation": "Użyj {model} dla tej lokalizacji",
  "forecastModels.forecastUseForStation": "Użyj {model} dla tej stacji",
  "forecastModels.forecastUsePreferred": "Użyj moich preferowanych modeli",
  "forecastModels.frequencyHourly": "Co godzinę",
  "forecastModels.horizon": "Horyzont",
  "forecastModels.horizonValue": "do {value} godz.",
  "forecastModels.meshSize": "Rozmiar siatki",
  "forecastModels.pickerShowAll": "Pokaż pełny katalog",
  "forecastModels.pickerUnreachable": "{count, plural, one {# kolejny model nie obejmuje} few {# kolejne modele nie obejmują} many {# kolejnych modeli nie obejmuje} other {# kolejnych modeli nie obejmuje}} żadnej z Twoich stacji",
  "forecastModels.pinInUse": "W użyciu",
  "forecastModels.pinShadowed": "Nigdy nieużywany — model powyżej obejmuje wszystkie Twoje stacje",
  "forecastModels.pinSlots": "{used} z {max} · wybierz model",
  "forecastModels.pinSlotsFull": "{max, plural, one {Jedyne miejsce jest zajęte. Usuń jego model, aby dodać inny.} few {Wszystkie # miejsca są zajęte. Usuń jedno, aby dodać inne.} many {Wszystkich # miejsc jest zajętych. Usuń jedno, aby dodać inne.} other {Wszystkie # miejsca są zajęte. Usuń jedno, aby dodać inne.}}",
  "forecastModels.pinsUncoveredCount": "{used} z Twoich {count, plural, one {# stacji} few {# stacji} many {# stacji} other {# stacji}}: żaden preferowany model {used, plural, =1 {jej} other {ich}} nie obejmuje — decyduje „wszędzie indziej”.",
  "forecastModels.pinsUncoveredNamed": "{stations}: żaden preferowany model {count, plural, one {jej nie obejmuje} other {ich nie obejmuje}} — decyduje „wszędzie indziej”.",
  "forecastModels.pinUnreachable": "Nigdy nieużywany — nie obejmuje żadnej z Twoich stacji",
  "forecastModels.pinUsedAt": "Używany na {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Używany na Twojej stacji} few {Używany na wszystkich # stacjach} many {Używany na wszystkich # stacjach} other {Używany na wszystkich # stacjach}}",
  "forecastModels.pinUsedAtSome": "Używany na {used} z {count, plural, one {# stacji} few {# stacji} many {# stacji} other {# stacji}}",
  "forecastModels.preferredModels": "Preferowane modele",
  "forecastModels.preferredModelsAll": "Jedna lista, wszystkie stacje",
  "forecastModels.preferredModelsOne": "Jedna lista, obowiązuje wszędzie",
  "forecastModels.publisher": "Wydawca",
  "forecastModels.removePreferredModel": "Usuń {model} z preferowanych modeli",
  "forecastModels.resetForecastPreference": "Przywróć domyślne",
  "forecastModels.resetForecastPreferenceHint": "Usuwa preferowane modele i przywraca domyślne ustawienie SmartMixin.",
  "forecastModels.servedNowMany": "W tej chwili: GFS {count, plural, one {na Twojej stacji} few {na wszystkich # stacjach} many {na wszystkich # stacjach} other {na wszystkich # stacjach}}.",
  "forecastModels.servedNowNone": "W tej chwili: GFS wszędzie.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Prognoza Weatherflow",
  "forecastModels.weatherForecastModels": "Modele prognoz pogody",
  "helpCenter.articleCount": "{count, plural, one {# artykuł} few {# artykuły} many {# artykułów} other {# artykułów}}",
  "helpCenter.articleNotFound": "Nie znaleziono artykułu",
  "helpCenter.articleNotFoundDescription": "Szukany artykuł nie istnieje.",
  "helpCenter.backToHelpCenter": "Wróć do centrum pomocy",
  "helpCenter.browseByCategory": "Przeglądaj według kategorii",
  "helpCenter.categoryNotFound": "Nie znaleziono kategorii",
  "helpCenter.categoryNotFoundDescription": "Ta kategoria nie istnieje lub nie zawiera artykułów.",
  "helpCenter.contactSupport": "Skontaktuj się z pomocą techniczną",
  "helpCenter.feedbackHelpsImprove": "Twoja opinia pomaga nam ulepszać nasze artykuły pomocy.",
  "helpCenter.feedbackReasonNotAnswer": "Nie odpowiada na moje pytanie",
  "helpCenter.feedbackReasonOutdated": "Informacje są nieaktualne",
  "helpCenter.feedbackReasonUnclear": "Instrukcje są niejasne",
  "helpCenter.feedbackWhatWentWrong": "Na czym polegał problem?",
  "helpCenter.helpCategoryAccount": "Konto",
  "helpCenter.helpCategoryBilling": "Płatności",
  "helpCenter.helpCategoryForecast": "Prognozy",
  "helpCenter.helpCategoryGettingStarted": "Pierwsze kroki",
  "helpCenter.helpCategoryProviders": "Dostawcy",
  "helpCenter.helpCategoryStations": "Stacje",
  "helpCenter.helpCategoryTroubleshooting": "Rozwiązywanie problemów",
  "helpCenter.helpCenter": "Centrum pomocy",
  "helpCenter.landingDescription": "Znajdź odpowiedzi na najczęstsze pytania i dowiedz się, jak w pełni wykorzystać SmartMixin.",
  "helpCenter.linkToSection": "Link do tej sekcji",
  "helpCenter.menuItemDescription": "Najczęściej zadawane pytania i poradniki",
  "helpCenter.minRead": "{minutes} min czytania",
  "helpCenter.onThisPage": "Na tej stronie",
  "helpCenter.platformMobileApp": "Aplikacja mobilna",
  "helpCenter.platformMobileOnly": "Tylko w aplikacji mobilnej",
  "helpCenter.platformWebApp": "Aplikacja internetowa",
  "helpCenter.platformWebOnly": "Tylko w aplikacji internetowej",
  "helpCenter.popularArticles": "Popularne artykuły",
  "helpCenter.relatedArticles": "Powiązane artykuły",
  "helpCenter.searchArticles": "Szukaj artykułów...",
  "helpCenter.stillNeedHelp": "Nadal potrzebujesz pomocy?",
  "helpCenter.stillNeedHelpDescription": "Jeśli ten artykuł nie odpowiedział na Twoje pytanie, chętnie pomogę Ci bezpośrednio.",
  "helpCenter.supportEmailSubject": "Pomoc SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Pomoc SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Dziękujemy za opinię!",
  "helpCenter.wasArticleHelpful": "Czy ten artykuł był pomocny?",
  "intro.locationDescription": "Włącz dostęp do lokalizacji, aby uzyskać dokładne prognozy dostosowane do Twojej dokładnej okolicy — koniec z uniwersalnymi prognozami.",
  "intro.locationTitle": "Prognozy stworzone dla Ciebie",
  "intro.notificationDescription": "Włącz powiadomienia, aby otrzymywać szybkie alerty o zmianach pogody, które są dla Ciebie ważne — deszcz, śnieg lub poważne warunki, dokładnie wtedy, gdy potrzebujesz wiedzieć.",
  "intro.notificationsTitle": "Nigdy nie przegap zmiany pogody",
  "intro.readyDescription": "Ciesz się precyzyjnymi prognozami, aktualnymi informacjami o pogodzie i danymi ze stacji na całym świecie — wszystko w jednej potężnej aplikacji.",
  "intro.readyTitle": "Jesteś gotowy!",
  "intro.welcomeDescription": "Uzyskaj hiperlokalne prognozy od najlepszych agencji meteorologicznych — plus dostęp do ponad 40 000 stacji pogodowych na całym świecie, aby zobaczyć rzeczywiste warunki, przeszłe i obecne.",
  "intro.welcomeTitle": "Twoja pogoda, na nowo przemyślana",
  "landing.alsoAvailableOn": "Dostępne również na:",
  "landing.featureAlertsDescription": "Ustaw własne progi dla dowolnego parametru. Otrzymuj powiadomienia, gdy temperatura spada, zaczyna padać deszcz lub wzmaga się wiatr.",
  "landing.featureAlertsTitle": "Inteligentne alerty",
  "landing.featureAnalyticsDescription": "Interaktywne wykresy, analiza trendów i szczegółowe statystyki. Zagłęb się w dane o temperaturze, wilgotności, ciśnieniu, deszczu i wietrze.",
  "landing.featureAnalyticsTitle": "Zaawansowana analityka",
  "landing.featureExportDescription": "Otrzymuj wszystkie dane pogodowe e-mailem w arkuszu Excel, gotowe do dalszej analizy w Excelu, Arkuszach Google lub ulubionych narzędziach.",
  "landing.featureExportTitle": "Eksportuj swoje dane",
  "landing.featureForecastDescription": "Dostęp do {count, plural, one {#+ profesjonalnego modelu prognozy} few {#+ profesjonalnych modeli prognozy} many {#+ profesjonalnych modeli prognozy} other {#+ profesjonalnych modeli prognozy}}, w tym ECMWF, GFS i modeli regionalnych. Porównuj je obok siebie i twórz własne prognozy.",
  "landing.featureForecastTitle": "Porównuj modele prognozy",
  "landing.featureHistoryDescription": "Dostęp do danych historycznych w skali godzinowej, dziennej i miesięcznej. Eksportuj je do Excela do badań lub archiwów osobistych.",
  "landing.featureHistoryTitle": "Bogata historia",
  "landing.featureMultiBrandDescription": "Połącz Netatmo, Davis, Tempest, Ecowitt, Ambient Weather i inne. Koniec z przełączaniem się między aplikacjami.",
  "landing.featureMultiBrandTitle": "Wszystkie marki, jedna aplikacja",
  "landing.featuresSubtitle": "SmartMixin daje Ci narzędzia do analizowania, porównywania i rozumienia danych pogodowych jak profesjonalista.",
  "landing.featuresTitle": "Stworzone dla miłośników danych",
  "landing.finalCtaButton": "Utwórz darmowe konto",
  "landing.finalCtaSubtitle": "Dołącz do tysięcy entuzjastów pogody, którzy ufają SmartMixin.",
  "landing.finalCtaTitle": "Chcesz głębiej poznać swoje dane pogodowe?",
  "landing.heroCta": "Zacznij za darmo",
  "landing.heroDescription": "Dogłębna analityka, piękne wykresy i profesjonalne prognozy — wszystkie Twoje stacje pogodowe w jednej potężnej aplikacji.",
  "landing.heroSecondaryCta": "Przeglądaj mapę",
  "landing.heroTagline": "Dla miłośników pogody",
  "landing.heroTitle": "Zobacz swoją pogodę jak nigdy dotąd",
  "landing.pricingComparisonCaption": "Porównanie funkcji planu bezpłatnego i Premium",
  "landing.pricingFeatureAdvancedMetrics": "Zaawansowane metryki",
  "landing.pricingFeatureAlerts": "Własne alerty",
  "landing.pricingFeatureColumn": "Funkcja",
  "landing.pricingFeatureExport": "Eksport danych (Excel)",
  "landing.pricingFeatureForecastComparison": "Porównanie prognoz",
  "landing.pricingFeatureForecasts": "Modele prognozy",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} few {#+ modele} many {#+ modeli} other {#+ modeli}}",
  "landing.pricingFeatureReports": "Analizy i raporty",
  "landing.pricingFeatureStationComparison": "Porównanie stacji",
  "landing.pricingFeatureWidgets": "Widżety ekranu głównego",
  "landing.pricingFeatureYearOverYear": "Analiza rok do roku",
  "landing.pricingFreeCta": "Rozpocznij",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najpopularniejszy",
  "landing.pricingPremiumCta": "Rozpocznij",
  "landing.pricingPremiumDescription": "Od 1,99 €/miesiąc — subskrybuj w sieci, App Store lub Google Play",
  "landing.pricingSubtitle": "Zacznij za darmo, ulepsz, gdy potrzebujesz więcej.",
  "landing.pricingTitle": "Proste, przejrzyste ceny",
  "landing.statBrands": "Obsługiwanych marek",
  "landing.statForecasts": "Modeli prognozy",
  "landing.statStations": "Stacji pogodowych",
  "landing.supportedDevicesNote": "Plus ponad {count, number} publicznych stacji z sieci Światowej Organizacji Meteorologicznej",
  "landing.supportedDevicesSubtitle": "Połącz swoją stację pogodową w kilka minut. Obsługujemy {count, plural, one {# główną markę} few {# główne marki} many {# głównych marek} other {# głównych marek}}, a kolejne są w drodze.",
  "landing.supportedDevicesTitle": "Działa z Twoją stacją",
  "metrics.absolutePressure": "Ciśnienie absolutne",
  "metrics.airDensity": "Gęstość powietrza",
  "metrics.airGap": "Szczelina powietrzna",
  "metrics.apparentTemperature": "Temperatura odczuwalna",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Średnia",
  "metrics.avg_wind": "Średni wiatr",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. czarnej kuli",
  "metrics.boilerOn": "Bojler Włączony",
  "metrics.boilerOnInHours": "Bojler Włączony (godziny)",
  "metrics.cloudCover": "Zachmurzenie",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Przewodność",
  "metrics.dailyPrecipitation": "Opady dobowe",
  "metrics.dailyRain": "Dzienny opad",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Głębokość",
  "metrics.depthSensors": "Czujniki głębokości",
  "metrics.dewPoint": "Punkt rosy",
  "metrics.distance": "Odległość",
  "metrics.downTrend": "w dół",
  "metrics.ET": "Ewapotranspiracja",
  "metrics.etToday": "ET dziś",
  "metrics.feelsLike": "Odczuwalna",
  "metrics.feelsLikeWithFormula": "Odczuwalna ({formula})",
  "metrics.frostPoint": "Punkt szronu",
  "metrics.gust": "Poryw",
  "metrics.gustDirection": "Kierunek porywu",
  "metrics.hail": "Grad",
  "metrics.heatIndex": "Indeks ciepła",
  "metrics.heatingDegreeDays": "Stopniodni ogrzewania",
  "metrics.heatingPower": "Moc grzewcza",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Wilgotność",
  "metrics.lastLightningImpact": "Ostatnie uderzenie",
  "metrics.lastMeasure": "Ostatni pomiar",
  "metrics.leafSensors": "Czujniki liści",
  "metrics.leafWetness": "Wilgotność liści",
  "metrics.lightningDistance": "Odległość",
  "metrics.lightningStrikeCount": "Liczba uderzeń pioruna",
  "metrics.lightningStrikeDistance": "Dystans uderzenia pioruna",
  "metrics.max": "Max.",
  "metrics.max_gust": "Maks. poryw",
  "metrics.maxToday": "Maks. dzisiaj",
  "metrics.min": "Min.",
  "metrics.noise": "Hałas",
  "metrics.normalizedHeatingCoefficient": "Znormalizowany współczynnik ciepła",
  "metrics.outdoorTemperature": "Temperatura zewnętrzna",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM 2,5",
  "metrics.precipitation": "Opady",
  "metrics.pressure": "Ciśnienie",
  "metrics.rain": "Deszcz",
  "metrics.rainDurationValue": "Czas trwania opadów: {duration}",
  "metrics.rainfallMeasurement": "Pomiar opadów",
  "metrics.rainRate": "Natężenie deszczu",
  "metrics.relativePressure": "Ciśnienie względne",
  "metrics.setPoint": "Wartość zadana",
  "metrics.snow": "Śnieg",
  "metrics.snowfall": "Opady śniegu",
  "metrics.soilMoisture": "Wilgotność",
  "metrics.soilSensors": "Czujniki gleby",
  "metrics.soilWaterTension": "Siła ssąca gleby",
  "metrics.solarEnergy": "Energia słoneczna",
  "metrics.solarRadiation": "Nasłonecznienie",
  "metrics.speed": "Prędkość",
  "metrics.stableTrend": "stabilny",
  "metrics.sum": "Suma",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Czujniki temperatury i wilgotności",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "w górę",
  "metrics.uv": "UV",
  "metrics.visibility": "Widoczność",
  "metrics.weatherCondition": "Warunki pogodowe",
  "metrics.wetBulbGlobeTemperature": "Temp. WBGT",
  "metrics.wetBulbTemperature": "Temp. mokrego termometru",
  "metrics.wind": "Wiatr",
  "metrics.windChill": "Chłód wiatru",
  "metrics.windDirection": "Kierunek wiatru",
  "metrics.windMeasurement": "Pomiar wiatru",
  "metrics.windRun": "Droga wiatru",
  "metrics.windRunDescription": "Droga wiatru to całkowita odległość przebyta przez wiatr w określonym czasie",
  "metrics.windSpeed": "Prędkość wiatru",
  "navigation.allFavorites": "Pokaż wszystkie",
  "navigation.breadcrumbs": "Ścieżka nawigacji",
  "navigation.collapseNavigation": "Zwiń nawigację",
  "navigation.expandNavigation": "Rozwiń nawigację",
  "navigation.main": "Główna",
  "navigation.mapShort": "Mapa",
  "navigation.skipToContent": "Przejdź do treści głównej",
  "navigation.stationsShort": "Stacje",
  "network.cancelError": "Żądanie zostało anulowane",
  "network.connectionError": "Serwer nie jest dostępny",
  "network.networkError": "Sieć niedostępna",
  "network.serverError": "Coś poszło nie tak...",
  "network.timeoutError": "Czas połączenia został przekroczony",
  "network.unknownError": "Nieznany błąd",
  "premium.alreadyPremium": "Masz już konto premium!",
  "premium.bestValue": "Najlepsza oferta",
  "premium.billingDetailsAndroid": "Bezpłatny okres próbny: nie zostaniesz obciążony, jeśli anulujesz co najmniej 24 godziny przed jego końcem. Później subskrypcja SmartMixin odnawia się automatycznie, chyba że anulujesz ją co najmniej 24 godziny przed końcem bieżącego okresu; możesz to zrobić w dowolnym momencie w ustawieniach konta Google Play. Każde odnowienie jest naliczane według ceny widocznej na przycisku powyżej. Płatność jest pobierana z konta Google Play przy potwierdzeniu zakupu i na początku każdego okresu odnowienia.",
  "premium.billingDetailsIos": "Bezpłatny okres próbny: nie zostaniesz obciążony, jeśli anulujesz co najmniej 24 godziny przed jego końcem. Później subskrypcja SmartMixin odnawia się automatycznie, chyba że anulujesz ją co najmniej 24 godziny przed końcem bieżącego okresu; możesz to zrobić w dowolnym momencie w ustawieniach konta App Store. Każde odnowienie jest naliczane według ceny widocznej na przycisku powyżej. Płatność jest pobierana z konta App Store przy potwierdzeniu zakupu i na początku każdego okresu odnowienia.",
  "premium.freeBannerBody": "Konta bezpłatne otrzymują GFS wszędzie — Twoje preferowane modele i „wszędzie indziej” zaczynają działać w chwili wykupienia subskrypcji.",
  "premium.freeBannerTitle": "Preferencje działają z Premium",
  "premium.freeSubscription": "Darmowa subskrypcja premium",
  "premium.freeTrialForPeriod": "Bezpłatny okres próbny przez {period, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "premium.getUnlimitedAccess": "Nieograniczony dostęp do:",
  "premium.manageMySubscription": "Zarządzaj moją subskrypcją",
  "premium.notPurchasedYet": "Nie znaleziono zakupu SmartMixin Premium na tym koncie sklepu.",
  "premium.orChooseMonthly": "Lub wybierz miesięcznie:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktywny",
  "premium.premiumAnnualTrialInfo": "Zacznij od bezpłatnego okresu próbnego na {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}",
  "premium.premiumCurrentPlan": "Aktualny plan",
  "premium.premiumDownloadApp": "Pobierz aplikację, aby się zasubskrybować:",
  "premium.premiumEndsOn": "Wygasa {date}",
  "premium.premiumFeatureAlerts": "Alerty pogodowe",
  "premium.premiumFeatureAnalysis": "Zaawansowana analiza pogody",
  "premium.premiumFeatureCharts": "Porównania wykresów",
  "premium.premiumFeatureExport": "Eksport danych",
  "premium.premiumFeatureForecast": "Regionalne modele prognoz",
  "premium.premiumFeatureNotification": "Widget paska stanu",
  "premium.premiumFeatureTitle": "Funkcja Premium",
  "premium.premiumFeatureWidgets": "Widżety ekranu głównego",
  "premium.premiumFreePlan": "Bezpłatny",
  "premium.premiumInactive": "Brak subskrypcji",
  "premium.premiumManageStoreSubscription": "Subskrypcja została kupiona przez {store}. Tam możesz nią zarządzać lub ją anulować.",
  "premium.premiumManageWebSubscription": "Zarządzaj subskrypcją, zaktualizuj metodę płatności lub anuluj.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Odnawia się {date}",
  "premium.premiumSubscribeAnnual": "Rocznie — 9,99 €/rok",
  "premium.premiumSubscribedOn": "Subskrypcja na {platform}",
  "premium.premiumSubscribedOnWeb": "Subskrypcja przez stronę internetową",
  "premium.premiumSubscribeMonthly": "Miesięcznie — 1,99 €/miesiąc",
  "premium.premiumSubscribeOnWeb": "Subskrybuj teraz, aby odblokować wszystkie funkcje premium.",
  "premium.premiumSubscriptionSuccess": "Twoja subskrypcja została aktywowana! Korzystaj ze wszystkich funkcji premium.",
  "premium.premiumSubscriptionSuccessTitle": "Witamy w Premium!",
  "premium.premiumWebappNotice": "Subskrypcja przez stronę internetową jest obecnie niedostępna.",
  "premium.pricePerMonth": "{price}/miesiąc",
  "premium.pricePerYear": "{price}/rok",
  "premium.purchasedNetatmoPro": "Wcześniej kupiłeś Netatmo Pro ({date}). Daje ono dostęp do części funkcji premium. Wybierz jedną z poniższych ofert subskrypcji, jeśli chcesz mieć dostęp do wszystkich funkcji premium.",
  "premium.purchaseFailed": "Nie udało się dokończyć zakupu. Spróbuj ponownie.",
  "premium.restoreFailed": "Nie udało się przywrócić zakupów. Spróbuj ponownie.",
  "premium.restorePurchase": "Przywróć zakup",
  "premium.savingsPercent": "Oszczędź {percent}%",
  "premium.seePremium": "Zobacz Premium",
  "premium.startFreeTrial": "Rozpocznij bezpłatny okres próbny",
  "premium.storeUnavailable": "Sklep jest teraz niedostępny. Spróbuj ponownie później.",
  "premium.subscribeNow": "Subskrybuj teraz — bez okresu próbnego",
  "premium.switchToPremium": "Przełącz na SmartMixin Premium",
  "premium.thenPrice": "potem {price}",
  "providerHints.ambientWeatherApiKey": "Utworzony w ustawieniach Twojego konta ambientweather.net.",
  "providerHints.davisApiSecret": "Wyświetlany tylko raz przy tworzeniu klucza API V2 — przechowuj go bezpiecznie.",
  "providerHints.davisV2ApiKey": "Ze strony kluczy API V2 na weatherlink.com.",
  "providerHints.ecowittApi": "Ze strony API Twojego konta Ecowitt.",
  "providerHints.ecowittApp": "Klucz aplikacji, również z Twojego konta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Użyj e-maila i hasła konta My AcuRite — nie loginu SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail Twojego konta My AcuRite — nie login SmartMixin.",
  "providerHints.myAcuritePassword": "Hasło Twojego konta My AcuRite.",
  "providerHints.weatherflowToken": "Token do użytku osobistego z tempestwx.com → ustawienia → autoryzacje danych.",
  "providerHints.wundergroundEditKey": "Użyj innego klucza",
  "providerHints.wundergroundKey": "Długi ciąg znaków ze strony kluczy API Twojego konta Weather Underground — nie Twoje hasło do wunderground.com.",
  "providerHints.wundergroundKeyExample": "np. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Klucz API zweryfikowany",
  "providerHints.wundergroundNoStationsNearby": "Nie znaleziono stacji w pobliżu tej lokalizacji. Spróbuj wprowadzić ID stacji bezpośrednio.",
  "providerHints.wundergroundStationIdExample": "np. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Uzyskaj swój klucz API Ambient Weather.",
  "providerIntro.davisStep2": "Uzyskaj swój klucz API V2 i sekret API Davis.",
  "providerIntro.ecowittStep2": "Uzyskaj swój klucz API i klucz aplikacji Ecowitt.",
  "providerIntro.getStarted": "Rozpocznij",
  "providerIntro.myAcuriteStep2": "Użyj e-maila i hasła istniejącego konta My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Zaloguj się do Netatmo gdy zostaniesz poproszony — klucz API nie jest potrzebny.",
  "providerIntro.netatmoWeatherStep2": "Zaloguj się do Netatmo gdy zostaniesz poproszony — klucz API nie jest potrzebny.",
  "providerIntro.signupBanner": "Prawie gotowe — utwórz darmowe konto SmartMixin, aby połączyć {provider}.",
  "providerIntro.step1": "Zaloguj się do konta SmartMixin (NIE do {provider}).",
  "providerIntro.step3EmailPassword": "Wprowadź je tutaj.",
  "providerIntro.step3KeyOrToken": "Wklej tutaj.",
  "providerIntro.step3OAuth": "Autoryzuj SmartMixin w wyskakującym okienku.",
  "providerIntro.step3Wunderground": "Wklej swój klucz API, a następnie wybierz stację w pobliżu lub wprowadź dowolny identyfikator stacji.",
  "providerIntro.stepOfTotal": "Krok {step} z {total}",
  "providerIntro.title": "Połącz {provider}",
  "providerIntro.weatherflowStep2": "Uzyskaj swój token Tempest do użytku osobistego.",
  "providerIntro.wundergroundBrowsePublic": "Nie masz stacji? Przejrzyj publiczne",
  "providerIntro.wundergroundFindNearby": "Znajdź stacje w pobliżu",
  "providerIntro.wundergroundOrEnterId": "Lub wprowadź ID stacji",
  "providerIntro.wundergroundStep2": "Uzyskaj swój klucz API Weather Underground. Następnie będziesz mógł połączyć dowolną stację — swoją lub publiczną.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Analiza",
  "reports.annualCumulativeRainfallComparison": "Porównanie rocznych skumulowanych opadów",
  "reports.annualHeatingDurationComparison": "Porównanie rocznego czasu ogrzewania",
  "reports.annualHeatingEfficiency": "Roczna wydajność grzewcza",
  "reports.annualIndoorComparison": "Roczne porównanie pomiarów wewnątrz",
  "reports.annualOutdoorComparison": "Roczne porównanie pomiarów zewnątrz",
  "reports.annualOutdoorReport": "Roczny raport pomiarów zewnętrznych",
  "reports.annualReport": "Raport roczny",
  "reports.annualSolarReport": "Roczny raport nasłonecznienia",
  "reports.annualWaterBalance": "Roczny bilans wodny",
  "reports.annualWaterBalanceCarryOver": "Przenieś z {year} r. ({value})",
  "reports.annualWaterBalanceDescription": "Bilans wodny (wersja uproszczona, wykorzystuje się tylko deszcz i ewapotranspirację) umożliwia zarządzanie zasobami wodnymi",
  "reports.avgHumidity": "Średnia wilgotność",
  "reports.avgMaxTemperature": "Średnia T°maks",
  "reports.avgMetric": "Średnia – {metric}",
  "reports.avgMinTemperature": "Średnia T°min",
  "reports.avgPressure": "Średnie ciśnienie",
  "reports.avgTemperature": "Średnia temperatura",
  "reports.chartsAndTable": "Wykresy i tabela",
  "reports.climateNormalPeriodOfRecord": "Okres pomiarowy ({years, plural, one {# rok} few {# lata} many {# lat} other {# roku}})",
  "reports.climateNormals": "Normy klimatyczne",
  "reports.climateNormalStandardLabel": "Norma standardowa ({period})",
  "reports.climateTrendPerDecade": "Trend temperatury: {value} na dziesięciolecie w ciągu {years, plural, one {# roku} few {# lat} many {# lat} other {# lat}}",
  "reports.coldestMonthRanking": "Najzimniejszy {month} w historii pomiarów",
  "reports.comfortable": "Komfortowe (45% {lessThan} Wilgotność ≤ 60%)",
  "reports.cumulativeRainfall": "Skumulowane opady",
  "reports.cumulativeRainfallDescription": "Śledź łączne opady kumulujące się w wybranym okresie.",
  "reports.dailyMaxRainfall": "Maksymalne dzienne opady",
  "reports.dataExport": "Eksport danych",
  "reports.dataExportXlsxFormatDescription": "Wyeksportuj wszystkie dane swojej stacji w formacie Excel (* .xlsx). Po kliknięciu przycisku otrzymasz wiadomość e-mail z przetworzonymi danymi po kilku minutach.",
  "reports.daysOfData": "{days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}} danych",
  "reports.daysWithFrost": "Dni z mrozem",
  "reports.daysWithHeavyRain": "Dni z silnym opadem (≥ {threshold})",
  "reports.daysWithoutThaw": "Dni bez odwilży",
  "reports.daysWithStrongFrost": "Dni z silnym mrozem",
  "reports.emailSent": "E-mail został wysłany do Ciebie",
  "reports.frostDays": "Dni przymrozkowe",
  "reports.grasslandTemperatureSum": "Suma temperatur użytków zielonych",
  "reports.grasslandTemperatureSumDescription": "Zrównoważona odbudowa roślinności, gdy suma osiągnie {threshold}",
  "reports.growingDegreeDays": "Stopniodni wzrostu",
  "reports.highPressure": "Anticyklon (ciśnienie średnie ≥ {threshold})",
  "reports.iceDays": "Dni mroźne",
  "reports.indoorReport": "Raport wewnętrzny",
  "reports.keyFacts": "Kluczowe fakty",
  "reports.longestDrySpell": "Najdłuższy okres bezopadowy",
  "reports.longestRunOfRainyDays": "Najdłuższa seria deszczowych dni",
  "reports.longestRunWithoutRun": "Najdłuższy okres bez deszczu",
  "reports.longestWetSpell": "Najdłuższy okres opadowy",
  "reports.lowPressure": "Niskie ciśnienie (ciśnienie średnie {lessThan} {threshold})",
  "reports.maxHumidity": "Maksymalna wilgotność",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Maksymalne ciśnienie",
  "reports.maxTemperature": "Maksymalna temperatura",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maksymalna amplituda (/24 godz.)",
  "reports.minHumidity": "Minimalna wilgotność",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimalne ciśnienie",
  "reports.minTemperature": "Minimalna temperatura",
  "reports.minTempMagnitude24h": "Minimalna amplituda (/24 godz.)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Jeszcze # dzień} few {Jeszcze # dni} many {Jeszcze # dni} other {Jeszcze # dnia}} w tym miesiącu",
  "reports.monthlyAverageCountdownDetail": "Wtedy pojawią się średnia miesiąca i jej ranking.",
  "reports.monthlyAverageRule": "Średnie miesięczne i rankingi pojawiają się, gdy miesiąc kalendarzowy ma zarejestrowane {days, plural, one {# dzień} few {# dni} many {# dni} other {# dnia}}.",
  "reports.monthlyHeatingEfficiency": "Miesięczna wydajność grzewcza",
  "reports.monthlyOutdoorReport": "Miesięczny raport zewnętrzny",
  "reports.monthlyReport": "Miesięczny raport",
  "reports.monthlySolarReport": "Miesięczny raport nasłonecznienia",
  "reports.monthlyWindReport": "Miesięczny raport z wiatru",
  "reports.monthsOfData": "{months, plural, one {# miesiąc} few {# miesiące} many {# miesięcy} other {# miesiąca}} danych",
  "reports.numberOfDays": "Liczba dni",
  "reports.outdoorReport": "Raport zewnętrzny",
  "reports.overviewSection": "Przegląd",
  "reports.rainfall": "Deszcz",
  "reports.rainyDays": "Deszczowe dni",
  "reports.recordClimatologicalDay": "Doba klimatologiczna (06–06 UTC)",
  "reports.recordClimDayBody": "Opady są tu sumowane dla dnia kalendarzowego, od północy do północy czasu stacji. Służby meteorologiczne sumują je od 06:00 do 06:00 UTC, więc burza na przełomie doby może sprawić, że najwyższy opad dobowy przypadnie na inny dzień.",
  "reports.recordDailyRain": "Najwyższy opad dobowy",
  "reports.recordFromHourlyReadings": "Z pomiarów godzinowych",
  "reports.recordHigh": "Rekord ciepła",
  "reports.recordLow": "Rekord zimna",
  "reports.recordOfficialBody": "Służba meteorologiczna publikuje dla tej stacji dobowe maksimum i minimum odczytane z termometrów maksymalnego i minimalnego. Wychwytują one krótkie szczyty, które umykają pomiarom godzinowym, dlatego zastępują wartości wyliczone z pomiarów godzinowych.",
  "reports.recordOfficialValue": "Wartość oficjalna",
  "reports.recordsAndClimatology": "Rekordy i klimat",
  "reports.recordSheetTitle": "O tych rekordach",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Najsilniejszy poryw wiatru",
  "reports.relativelyWet": "Dość wilgotne (60 % {lessThan} Wilgotność ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# raport} few {# raporty} many {# raportów} other {# raportów}}",
  "reports.sendEmail": "Wyślij e-mail",
  "reports.summerDays": "Dni letnie",
  "reports.tableScrollRegion": "{title}, przewija się w poziomie",
  "reports.tooDry": "Zbyt suche (wilgotność ≤ 45%)",
  "reports.tooWet": "Zbyt wilgotne (Wilgotność {greaterThan} 80%)",
  "reports.tropicalNights": "Tropikalne noce",
  "reports.unlockPremiumSubtitle": "Zawarte w SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odblokuj {count, plural, one {# funkcję premium} few {# funkcje premium} many {# funkcji premium} other {# funkcji premium}}",
  "reports.warmestMonthRanking": "Najcieplejszy {month} w historii pomiarów",
  "reports.waterBalance": "Bilans wodny",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# lata} many {# lat} other {# roku}} danych",
  "reports.yearToDateTemperatureComparison": "Porównanie temperatur od początku roku",
  "sensors.bgtSensors": "Czarna kula & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Porównaj wilgotność",
  "sensors.compareMoisture": "Porównaj wilgotność gleby",
  "sensors.comparePm25": "Porównaj PM2.5",
  "sensors.compareTemperatures": "Porównaj temperatury",
  "sensors.compareWaterTension": "Porównaj siłę ssącą gleby",
  "sensors.depthByChannel": "Głębokość wg kanału",
  "sensors.heatStressExtreme": "Ekstremalny stres cieplny",
  "sensors.heatStressModerate": "Umiarkowany stres cieplny",
  "sensors.heatStressNone": "Brak stresu cieplnego",
  "sensors.heatStressStrong": "Silny stres cieplny",
  "sensors.heatStressVeryStrong": "Bardzo silny stres cieplny",
  "sensors.indoorClimate": "Klimat wewnętrzny",
  "sensors.indoorCo2Levels": "Poziomy CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i wilgotność",
  "sensors.leafWetnessByChannel": "Wilgotność liści wg kanału",
  "sensors.lightningSensor": "Błyskawica",
  "sensors.moistureByChannel": "Wilgotność gleby wg kanału",
  "sensors.noDataAvailable": "Brak dostępnych danych",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 wg kanału",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Wybierz kanał",
  "sensors.sensorDetailDescription": "Przeglądaj dane historyczne i trendy dla kanałów czujnika.",
  "sensors.sensorHistory": "Historia czujnika",
  "sensors.soilConductivityByChannel": "Przewodność wg kanału",
  "sensors.soilTemperatureByChannel": "Temperatura gleby wg kanału",
  "sensors.strikesToday": "Uderzenia dzisiaj",
  "sensors.temperatureByChannel": "Temperatura wg kanału",
  "sensors.viewChart": "Zobacz wykres",
  "sensors.waterTensionByChannel": "Siła ssąca gleby wg kanału",
  "settings.appearance": "Wygląd",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabski",
  "settings.bulgarian": "bułgarski",
  "settings.catalan": "kataloński",
  "settings.chartGestures": "Gesty na wykresach",
  "settings.chartGesturesDescription": "Przesuwanie palcem po wykresach zmienia przedział czasu, szczypanie wykresów zmienia skalę czasu",
  "settings.choiceCount": "{count, plural, one {Dostępny: #} few {Dostępne: #} many {Dostępnych: #} other {Dostępnych: #}}",
  "settings.contactUs": "Kontakt",
  "settings.contactUsDescription": "Uzyskaj pomoc lub wyślij opinię",
  "settings.croatian": "chorwacki",
  "settings.czech": "czeski",
  "settings.dailyDetailByPeriods": "Szczegóły dnia według pór dnia",
  "settings.dailyDetailByPeriodsDescription": "Grupuj 24 godziny na noc, rano, popołudnie i wieczór — ten sam podział, którego używa podsumowanie dnia.",
  "settings.danish": "duński",
  "settings.dark": "Ciemny motyw",
  "settings.dataDisplay": "Wyświetlanie danych",
  "settings.dateAndTime": "Data i czas",
  "settings.donateButton": "Przekaż darowiznę",
  "settings.donateDescription": "SmartMixin tworzy mały zespół. Jeśli aplikacja jest dla Ciebie przydatna, możesz wesprzeć jej rozwój jednorazową darowizną w dowolnej kwocie. To prezent — nie zmienia Twojego planu ani nie odblokowuje żadnych funkcji.",
  "settings.donateSuccessBody": "Twoja darowizna pomaga utrzymać działanie SmartMixin i go ulepszać. Bardzo to doceniamy.",
  "settings.donateSuccessTitle": "Dziękujemy za wsparcie!",
  "settings.donateTitle": "Wesprzyj SmartMixin",
  "settings.dragToReorder": "Przeciągnij, aby zmienić kolejność",
  "settings.dutch": "holenderski",
  "settings.english": "angielski",
  "settings.french": "francuski",
  "settings.german": "niemiecki",
  "settings.gestures": "Gesty",
  "settings.greek": "grecki",
  "settings.hungarian": "węgierski",
  "settings.italian": "włoski",
  "settings.japanese": "japoński",
  "settings.korean": "koreański",
  "settings.language": "Język",
  "settings.languageDescription": "Preferowany język",
  "settings.light": "Jasny motyw",
  "settings.measurementUnits": "Jednostki miary",
  "settings.netatmoDashboard": "Pulpit Netatmo",
  "settings.netatmoLayoutCards": "Lista kart",
  "settings.netatmoLayoutCardsDescription": "Jedna karta na moduł, wszystko na jednym ekranie",
  "settings.netatmoLayoutClassic": "Klasyczny",
  "settings.netatmoLayoutClassicDescription": "Dwie karty, przesuwanie między modułami",
  "settings.netatmoNewLayoutNotice": "Nowy układ pulpitu: jedna karta na moduł.",
  "settings.netatmoSwitchBackToClassic": "Wróć do klasycznego",
  "settings.netatmoSwitchToLayout": "Przełącz na: {layout}",
  "settings.norwegian": "norweski",
  "settings.notificationsSection": "Powiadomienia",
  "settings.ongoingNotificationEnabled": "Włącz stałe powiadomienie",
  "settings.ongoingNotificationMetrics": "Wyświetlane wskaźniki",
  "settings.ongoingNotificationPermissionRequired": "Wymagane uprawnienie do powiadomień",
  "settings.ongoingNotificationPreviewHint": "Podgląd — włącz widget, aby go pokazać",
  "settings.ongoingNotificationStatusBar": "Pasek stanu",
  "settings.polish": "polski",
  "settings.portuguese": "portugalski",
  "settings.preferencesSection": "Preferencje",
  "settings.privacyPolicy": "Polityka prywatności",
  "settings.russian": "rosyjski",
  "settings.serbian": "serbski",
  "settings.settings": "Ustawienia",
  "settings.settingsPageTitle": "Ustawienia - {page}",
  "settings.slovak": "słowacki",
  "settings.smallDecimals": "Małe miejsca dziesiętne",
  "settings.smallDecimalsDescription": "Wyświetlaj cyfry dziesiętne w mniejszym rozmiarze",
  "settings.spanish": "hiszpański",
  "settings.statusBarWidget": "Widget paska stanu",
  "settings.statusBarWidgetDescription": "Zawsze widoczne dane pogodowe",
  "settings.subscriptionSection": "Subskrypcja",
  "settings.supportSection": "Wsparcie",
  "settings.swedish": "szwedzki",
  "settings.systemTheme": "Motyw systemowy",
  "settings.termsOfService": "Warunki usługi",
  "settings.themeDarkShort": "Ciemny",
  "settings.themeLightShort": "Jasny",
  "settings.themeSystemShort": "Systemowy",
  "settings.turkish": "turecki",
  "settings.ukrainian": "ukraiński",
  "settings.units": "Jednostki",
  "settings.unitsDescription": "Jednostki miary wyświetlane w aplikacji",
  "settings.update": "Zaktualizuj",
  "settings.windDirectionConvention": "Strzałka kierunku wiatru",
  "settings.windDirectionConventionDescription": "Wybierz sposób wyświetlania strzałek kierunku wiatru",
  "settings.windDirectionMeteorological": "Kierunek pochodzenia",
  "settings.windDirectionMeteorologicalDescription": "Strzałka wskazuje skąd wieje wiatr (konwencja meteorologiczna)",
  "settings.windDirectionOceanographic": "Kierunek przepływu",
  "settings.windDirectionOceanographicDescription": "Strzałka wskazuje dokąd wieje wiatr (konwencja oceanograficzna)",
  "stations.addAStation": "Dodaj stację",
  "stations.addToFavorites": "Dodaj do ulubionych",
  "stations.addYourOwnStation": "Dodaj swoją stację",
  "stations.clearRecentLocations": "Wyczyść wszystko",
  "stations.clearSearch": "Wyczyść wyszukiwanie",
  "stations.currentLocation": "Aktualna lokalizacja",
  "stations.customizedStationName": "Własna nazwa stacji",
  "stations.favoriteLocations": "Ulubione",
  "stations.favoriteLocationsEmpty": "Możesz dodać do 5 ulubionych lokalizacji.",
  "stations.favoriteStations": "Ulubione stacje",
  "stations.filterStationDescription": "Nie wyświetlaj stacji z niewiarygodnymi pomiarami",
  "stations.filterStations": "Filtruj stacje",
  "stations.filterStationSourceDescription": "Wybierz dostawców stacji, których chcesz wyświetlić na mapie",
  "stations.findStationsNearYou": "Znajdź stacje w pobliżu",
  "stations.hiddenStations": "Ukryte stacje",
  "stations.hiddenStationsDescription": "Możesz ponownie wyświetlić stację, dotykając ikony oka obok niej.",
  "stations.hideStationNamed": "Ukryj {station}",
  "stations.lastSeen": "ostatnio {time}",
  "stations.loadingStation": "Wczytywanie stacji…",
  "stations.location": "Lokalizacja",
  "stations.locationAddedToFavorites": "Lokalizacja dodana do ulubionych",
  "stations.locationNotGranted": "Nie udzielono uprawnień do lokalizacji. Zezwól na dostęp do lokalizacji w ustawieniach urządzenia.",
  "stations.locationRemovedFromFavorites": "Lokalizacja usunięta z ulubionych",
  "stations.locations": "Lokalizacje",
  "stations.locationUnavailable": "Nie można ustalić Twojej lokalizacji. Sprawdź ustawienia urządzenia.",
  "stations.maxFavoriteLocationsReached": "Możesz mieć maksymalnie 5 ulubionych lokalizacji. Usuń jedną, aby dodać inną.",
  "stations.modifyFavoriteStations": "Zmodyfikuj ulubione stacje",
  "stations.modifyFavoriteStationsDescription": "Możesz zmienić kolejność ulubionych stacji, przeciągając je. Możesz je również usunąć z listy.",
  "stations.myLocation": "Moja lokalizacja",
  "stations.nearbyWeatherStations": "Pobliskie stacje pogodowe",
  "stations.noLocationsFound": "Nie znaleziono lokalizacji",
  "stations.noLongerReported": "Nie ma jej już na liście",
  "stations.noLongerReportedBy": "{provider}: brak na liście od {date}",
  "stations.noSearchResults": "Żaden artykuł nie pasuje do wyszukiwania",
  "stations.noStationsFound": "Nie znaleziono stacji",
  "stations.noWeatherStationYet": "Nie masz jeszcze stacji meteorologicznej.",
  "stations.recentLocations": "Ostatnie",
  "stations.recentLocationsEmpty": "Twoja historia jest pusta.",
  "stations.removeFromFavorites": "Usuń z ulubionych",
  "stations.removeStationNamed": "Usuń {station} z ulubionych",
  "stations.reorderStationNamed": "Przenieś {station}",
  "stations.searchForLocation": "Szukaj lokalizacji",
  "stations.searchForWeatherStation": "Szukaj stacji pogody",
  "stations.searchResults": "Wyniki wyszukiwania",
  "stations.searchResultsEmpty": "Nie znaleziono żadnych wyników.",
  "stations.searchResultsFound": "{count, plural, one {Znaleziono # wynik} few {Znaleziono # wyniki} many {Znaleziono # wyników} other {Znaleziono # wyniku}}",
  "stations.searchStationsDescription": "Wpisz miasto, adres lub nazwę miejsca, aby znaleźć pobliskie stacje pogodowe.",
  "stations.searchStationsHint": "Użyj paska wyszukiwania powyżej, aby odkryć stacje pogodowe w dowolnym miejscu na świecie.",
  "stations.selectStationForComparison": "Wybierz stację do porównania",
  "stations.stationAddedToFavorites": "Stacja dodana do ulubionych",
  "stations.stationCount": "{count, plural, one {# stacja} few {# stacje} many {# stacji} other {# stacji}}",
  "stations.stationInformation": "Informacje o stacji",
  "stations.stationName": "Nazwa stacji",
  "stations.stationObservationsDescription": "Wyświetl najnowsze obserwacje ze stacji pogodowych",
  "stations.stationRemovedFromFavorites": "Stacja usunięta z ulubionych",
  "stations.stationsLoading": "Wczytywanie stacji pogodowych",
  "stations.stationsNear": "Stacje w pobliżu: {place}",
  "stations.stationType": "Typ stacji",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Nieaktualne",
  "stations.tryAnotherLocation": "Nie znaleźliśmy stacji pogodowych w pobliżu tej lokalizacji. Spróbuj wyszukać w innym obszarze.",
  "stations.unhideStationNamed": "Pokaż ponownie {station}",
  "stations.weatherStation": "Stacja pogodowa",
  "stations.weatherStationCount": "{count, plural, one {# stacja pogodowa} few {# stacje pogodowe} many {# stacji pogodowych} other {# stacji pogodowej}}",
  "stations.weatherStations": "Stacje pogodowe",
  "stations.welcomeConnectService": "Posiadasz stację pogodową? Podłącz swoją usługę",
  "stations.welcomeSubtitle": "Twoja pogoda, wszystko w jednym miejscu",
  "thermostat.away": "Poza domem",
  "thermostat.boilerOn": "Bojler włączony",
  "thermostat.hg": "Ochrona przed mrozem",
  "thermostat.homeInformation": "Informacje o domu",
  "thermostat.homeName": "Nazwa domu",
  "thermostat.manualBoost": "Ręczne zwiększenie",
  "thermostat.manualSetpointUntil": "Ręczna nastawa do",
  "thermostat.noThermostatYet": "Nie masz jeszcze termostatu.",
  "thermostat.relay": "Przekaźnik",
  "thermostat.room": "Pokój",
  "thermostat.rooms": "Pokoje",
  "thermostat.smartThermostat": "Inteligentny termostat",
  "thermostat.smartValve": "Inteligentny zawór",
  "thermostat.whenBackHome": "Kiedy wrócisz do domu?",
  "units.celsius": "Celsjusz",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Cale",
  "units.inchOfMercury": "Cale rtęci",
  "units.kelvin": "Kelwin",
  "units.kilometerPerHour": "Kilometry na godzinę",
  "units.knot": "Węzły",
  "units.meterPerSecond": "Metry na sekundę",
  "units.milePerHour": "Mile na godzinę",
  "units.millibar": "Milibary",
  "units.millimeter": "Milimetry",
  "units.millimeterOfMercury": "Milimetry rtęci",
  "weatherConditions.blizzard": "Zamieć śnieżna",
  "weatherConditions.blowingDust": "Unoszący się pył",
  "weatherConditions.blowingSnow": "Śnieg unoszony przez wiatr",
  "weatherConditions.breezy": "Lekki wiatr",
  "weatherConditions.clear": "Bezchmurnie",
  "weatherConditions.cloudy": "Pochmurno",
  "weatherConditions.drizzle": "Mżawka",
  "weatherConditions.flurries": "Lekkie opady śniegu",
  "weatherConditions.foggy": "Mgła",
  "weatherConditions.freezingDrizzle": "Marznąca mżawka",
  "weatherConditions.freezingRain": "Marznący deszcz",
  "weatherConditions.frigid": "Silny mróz",
  "weatherConditions.hail": "Grad",
  "weatherConditions.haze": "Zmętnienie",
  "weatherConditions.heavyRain": "Silny deszcz",
  "weatherConditions.heavySnow": "Intensywne opady śniegu",
  "weatherConditions.hot": "Upał",
  "weatherConditions.hurricane": "Huragan",
  "weatherConditions.isolatedThunderstorms": "Pojedyncze burze",
  "weatherConditions.mixedRainAndHail": "Deszcz z gradem",
  "weatherConditions.mostlyClear": "Przeważnie bezchmurnie",
  "weatherConditions.mostlyCloudy": "Przeważnie pochmurno",
  "weatherConditions.mostlySunny": "Przeważnie słonecznie",
  "weatherConditions.notAvailable": "Warunki pogodowe niedostępne",
  "weatherConditions.partlyCloudy": "Częściowe zachmurzenie",
  "weatherConditions.rain": "Deszcz",
  "weatherConditions.rainSleet": "Deszcz z krupą lodową",
  "weatherConditions.rainSnow": "Deszcz ze śniegiem",
  "weatherConditions.scatteredShowers": "Miejscami przelotne opady deszczu",
  "weatherConditions.scatteredSnowShowers": "Miejscami przelotne opady śniegu",
  "weatherConditions.scatteredThunderstorms": "Rozproszone burze",
  "weatherConditions.showers": "Przelotne opady deszczu",
  "weatherConditions.sleet": "Krupa lodowa",
  "weatherConditions.smoke": "Dym",
  "weatherConditions.snow": "Śnieg",
  "weatherConditions.snowShowers": "Przelotne opady śniegu",
  "weatherConditions.strongStorms": "Silne burze",
  "weatherConditions.sunny": "Słonecznie",
  "weatherConditions.thunderstorms": "Burze",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Burza tropikalna",
  "weatherConditions.windy": "Wietrznie",
  "weatherConditions.wintryMix": "Mieszane opady zimowe",
  "weatherMap.clusterMarkerName": "{metric} {value}, mediana z {count, plural, one {# stacji} few {# stacji} many {# stacji} other {# stacji}}, przybliż",
  "weatherMap.legendHeavy": "Silne",
  "weatherMap.legendLight": "Słabe",
  "weatherMap.legendLightningHelp": "Kolor pokazuje wiek każdego wyładowania w ciągu ostatnich {minutes} minut — najnowsze na biało, najstarsze na ciemnoczerwono.",
  "weatherMap.legendNewest": "Najnowsze",
  "weatherMap.legendOldest": "Najstarsze",
  "weatherMap.legendStationsHelp": "Kolor znacznika odzwierciedla wartość wybranego wskaźnika.",
  "weatherMap.lightningDataAttribution": "Dane o wyładowaniach: Blitzortung.org",
  "weatherMap.lightningStrikes": "Wyładowania atmosferyczne",
  "weatherMap.lightningStrikesDescription": "Pokazuj wyładowania atmosferyczne na mapie w czasie rzeczywistym",
  "weatherMap.mapLayers": "Warstwy mapy",
  "weatherMap.mapLegend": "Legenda mapy",
  "weatherMap.mapMode": "Tryb mapy",
  "weatherMap.mapNameForecast": "Mapa prognozy, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mapa pogody, obserwacje",
  "weatherMap.modeForecast": "Prognoza",
  "weatherMap.modeObservations": "Obserwacje",
  "weatherMap.radarDataAttribution": "Dane radarowe: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Czas zdjęcia radarowego",
  "weatherMap.rainRadar": "Radar opadów",
  "weatherMap.rainRadarDescription": "Wyświetl nakładkę radaru deszczu na mapie",
  "weatherMap.resetBearing": "Przeciągnij, aby obrócić mapę, kliknij, aby ustawić ją północą do góry",
  "weatherMap.showingForecast": "Wyświetlana prognoza: {model}, {variable}",
  "weatherMap.signInForecastBody": "Mapy GFS są bezpłatne z kontem SmartMixin. Z Premium dostępnych jest więcej modeli.",
  "weatherMap.signInForecastTitle": "Zaloguj się, aby zobaczyć mapy prognoz",
  "weatherMap.stationMarkerName": "{metric} {value}, jedna stacja",
  "weatherMap.stationMarkersHint": "Strzałkami przechodzisz między stacjami",
  "weatherMap.stationMarkerWindValue": "{speed}, kierunek {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain to dodatkowe źródło danych dostarczane przez system pogodowy Tempest, wykorzystujący technologię Nearcast. Dane NC Rain to szacunkowa średnia akumulacja opadów wokół urządzenia Tempest na poziomie sąsiedztwa",
  "weatherMap.weatherMap": "Mapa pogody",
  "weatherMap.weatherMapMetaDescription": "SmartMixin oferuje interaktywne mapy pogody i radaru dla warunków pogodowych na całym świecie.",
  "weatherMap.zoomIn": "Przybliż",
  "weatherMap.zoomOut": "Oddal",
  "weatherWarnings.activeNow": "Aktywne teraz",
  "weatherWarnings.agencyMessage": "Komunikat służby meteorologicznej",
  "weatherWarnings.areaCovered": "Obszar objęty ostrzeżeniem",
  "weatherWarnings.areaThisLocation": "{area} (ta lokalizacja)",
  "weatherWarnings.areaYourStation": "{area} (Twoja stacja pogodowa)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Oficjalne ostrzeżenie, {severity}: {hazard}} one {Oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} few {Oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} many {Oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} other {Oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Nadchodzące oficjalne ostrzeżenie, {severity}: {hazard}} one {Nadchodzące oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} few {Nadchodzące oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} many {Nadchodzące oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #} other {Nadchodzące oficjalne ostrzeżenie, {severity}: {hazard}, i jeszcze #}}",
  "weatherWarnings.crumb": "Oficjalne ostrzeżenia",
  "weatherWarnings.emptyBody": "Krajowa służba meteorologiczna nie wydała dla tego miejsca żadnego obowiązującego ostrzeżenia. Sprawdzamy ponownie co kilka minut.",
  "weatherWarnings.emptyTitle": "Brak oficjalnych ostrzeżeń",
  "weatherWarnings.ended": "Zakończone",
  "weatherWarnings.endedAt": "To ostrzeżenie wygasło {time}.",
  "weatherWarnings.errorBody": "Sprawdź połączenie. Ponawiamy próbę co kilka minut.",
  "weatherWarnings.errorTitle": "Nie udało się wczytać oficjalnych ostrzeżeń",
  "weatherWarnings.fromTime": "Od {time}",
  "weatherWarnings.hazardAirQuality": "Jakość powietrza",
  "weatherWarnings.hazardAvalanche": "Lawiny",
  "weatherWarnings.hazardCoastalEvent": "Zagrożenia na wybrzeżu",
  "weatherWarnings.hazardFlood": "Powodzie",
  "weatherWarnings.hazardFog": "Mgła",
  "weatherWarnings.hazardForestFire": "Pożary lasów",
  "weatherWarnings.hazardHighTemperature": "Wysokie temperatury",
  "weatherWarnings.hazardLowTemperature": "Niskie temperatury",
  "weatherWarnings.hazardOther": "Inne zagrożenie",
  "weatherWarnings.hazardRain": "Deszcz",
  "weatherWarnings.hazardSnowIce": "Śnieg i oblodzenie",
  "weatherWarnings.hazardThunderstorm": "Burze",
  "weatherWarnings.hazardUv": "Promieniowanie UV",
  "weatherWarnings.hazardWind": "Wiatr",
  "weatherWarnings.hideHazards": "Ukryj zagrożenia",
  "weatherWarnings.issuedBy": "Wydane przez: {sender}",
  "weatherWarnings.lastUpdate": "Ostatnia aktualizacja: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa obszaru objętego ostrzeżeniem: {area}.} other {Mapa obszarów objętych ostrzeżeniem, łącznie #. Wyróżniono: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mapa obszaru objętego ostrzeżeniem.} other {Mapa obszarów objętych ostrzeżeniem, łącznie #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa niedostępna. Obszar jest wymieniony poniżej.} other {Mapa niedostępna. Lista obszarów (#) znajduje się poniżej.}}",
  "weatherWarnings.moreHazards": "+ {count} więcej: {hazards}",
  "weatherWarnings.notInLanguage": "Niedostępne w języku: {language}. Wyświetlono w wersji opublikowanej przez służbę meteorologiczną.",
  "weatherWarnings.openOn": "Otwórz na stronie {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # inny obszar} few {+ # inne obszary} many {+ # innych obszarów} other {+ # innego obszaru}}",
  "weatherWarnings.severityExtreme": "Ekstremalny",
  "weatherWarnings.severityFrom": "{severity} od {time}",
  "weatherWarnings.severityMinor": "Niski",
  "weatherWarnings.severityModerate": "Umiarkowany",
  "weatherWarnings.severityNow": "{severity} teraz",
  "weatherWarnings.severitySevere": "Poważny",
  "weatherWarnings.severityUntil": "{severity} do {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Pokaż # obszar} few {Pokaż wszystkie # obszary} many {Pokaż wszystkie # obszarów} other {Pokaż wszystkie # obszaru}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Pokaż # obszar na mapie} few {Pokaż wszystkie # obszary na mapie} many {Pokaż wszystkie # obszarów na mapie} other {Pokaż wszystkie # obszaru na mapie}}",
  "weatherWarnings.showHazards": "Pokaż zagrożenia",
  "weatherWarnings.showPeriods": "{count, plural, one {Pokaż # okres} few {Pokaż wszystkie # okresy} many {Pokaż wszystkie # okresów} other {Pokaż wszystkie # okresu}}",
  "weatherWarnings.source": "Źródło: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, następnie {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# oficjalne ostrzeżenie pogodowe} few {# oficjalne ostrzeżenia pogodowe} many {# oficjalnych ostrzeżeń pogodowych} other {# oficjalnego ostrzeżenia pogodowego}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Oficjalne ostrzeżenia pogodowe",
  "weatherWarnings.todayAt": "dzisiaj o {time}",
  "weatherWarnings.tomorrow": "Jutro",
  "weatherWarnings.tomorrowAt": "jutro o {time}",
  "weatherWarnings.upcoming": "Nadchodzące",
  "weatherWarnings.viewAll": "Wszystkie oficjalne ostrzeżenia",
  "weatherWarnings.whatToDo": "Co robić"
}
